/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as SiteAlertRouteImport } from './routes/site-alert'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IpBansRouteImport } from './routes/ip-bans'
import { Route as DiffRouteImport } from './routes/diff'
import { Route as AdminUsersRouteImport } from './routes/admin-users'
import { Route as UsersRouteRouteImport } from './routes/users/route'
import { Route as TransactionsRouteRouteImport } from './routes/transactions/route'
import { Route as TasksRouteRouteImport } from './routes/tasks/route'
import { Route as ShippingRatesRouteRouteImport } from './routes/shipping-rates/route'
import { Route as SellerPromotionsRouteRouteImport } from './routes/seller-promotions/route'
import { Route as ReferralsRouteRouteImport } from './routes/referrals/route'
import { Route as ProductsRouteRouteImport } from './routes/products/route'
import { Route as PostageStampsRouteRouteImport } from './routes/postage-stamps/route'
import { Route as OrdersRouteRouteImport } from './routes/orders/route'
import { Route as OffersRouteRouteImport } from './routes/offers/route'
import { Route as ModerationRouteRouteImport } from './routes/moderation/route'
import { Route as LiveEventsRouteRouteImport } from './routes/live-events/route'
import { Route as IntegrationAppsRouteRouteImport } from './routes/integration-apps/route'
import { Route as GamesRouteRouteImport } from './routes/games/route'
import { Route as ExpansionsRouteRouteImport } from './routes/expansions/route'
import { Route as ExpansionGroupsRouteRouteImport } from './routes/expansion-groups/route'
import { Route as CreatorCodesRouteRouteImport } from './routes/creator-codes/route'
import { Route as CrawlRouteRouteImport } from './routes/crawl/route'
import { Route as CouponsRouteRouteImport } from './routes/coupons/route'
import { Route as ContestsRouteRouteImport } from './routes/contests/route'
import { Route as BuyerPromotionsRouteRouteImport } from './routes/buyer-promotions/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as TransactionsIndexRouteImport } from './routes/transactions/index'
import { Route as TasksIndexRouteImport } from './routes/tasks/index'
import { Route as ShippingRatesIndexRouteImport } from './routes/shipping-rates/index'
import { Route as SellerPromotionsIndexRouteImport } from './routes/seller-promotions/index'
import { Route as ReviewAppealsIndexRouteImport } from './routes/review-appeals/index'
import { Route as ReferralsIndexRouteImport } from './routes/referrals/index'
import { Route as ProductsIndexRouteImport } from './routes/products/index'
import { Route as PriceDataAccessIndexRouteImport } from './routes/price-data-access/index'
import { Route as PostageStampsIndexRouteImport } from './routes/postage-stamps/index'
import { Route as OrdersIndexRouteImport } from './routes/orders/index'
import { Route as OffersIndexRouteImport } from './routes/offers/index'
import { Route as ModerationIndexRouteImport } from './routes/moderation/index'
import { Route as LiveEventsIndexRouteImport } from './routes/live-events/index'
import { Route as IntegrationAppsIndexRouteImport } from './routes/integration-apps/index'
import { Route as GamesIndexRouteImport } from './routes/games/index'
import { Route as ExpansionsIndexRouteImport } from './routes/expansions/index'
import { Route as ExpansionGroupsIndexRouteImport } from './routes/expansion-groups/index'
import { Route as DiscordBotIndexRouteImport } from './routes/discord-bot/index'
import { Route as DevToolsIndexRouteImport } from './routes/dev-tools/index'
import { Route as CreatorCodesIndexRouteImport } from './routes/creator-codes/index'
import { Route as CrawlIndexRouteImport } from './routes/crawl/index'
import { Route as CouponsIndexRouteImport } from './routes/coupons/index'
import { Route as CouponRequestsIndexRouteImport } from './routes/coupon-requests/index'
import { Route as ContestsIndexRouteImport } from './routes/contests/index'
import { Route as CatalogueV2IndexRouteImport } from './routes/catalogue-v2/index'
import { Route as CardScannerIndexRouteImport } from './routes/card-scanner/index'
import { Route as BuyerPromotionsIndexRouteImport } from './routes/buyer-promotions/index'
import { Route as ApiUsageIndexRouteImport } from './routes/api-usage/index'
import { Route as ApiRequestsIndexRouteImport } from './routes/api-requests/index'
import { Route as AccountingIndexRouteImport } from './routes/accounting/index'
import { Route as TvScreenKeyRouteImport } from './routes/tv.$screenKey'
import { Route as SellerPromotionsNewRouteImport } from './routes/seller-promotions/new'
import { Route as ReferralsBatchesRouteImport } from './routes/referrals/batches'
import { Route as PostageStampsSheetIdRouteImport } from './routes/postage-stamps/$sheetId'
import { Route as ModerationIpBansRouteImport } from './routes/moderation/ip-bans'
import { Route as LiveEventsNewRouteImport } from './routes/live-events/new'
import { Route as IntegrationAppsNewRouteImport } from './routes/integration-apps/new'
import { Route as GamesIdRouteImport } from './routes/games/$id'
import { Route as CrawlSpendingRouteImport } from './routes/crawl/spending'
import { Route as CrawlSettingsRouteImport } from './routes/crawl/settings'
import { Route as CrawlPricesRouteImport } from './routes/crawl/prices'
import { Route as CrawlHealthRouteImport } from './routes/crawl/health'
import { Route as CrawlDataRouteImport } from './routes/crawl/data'
import { Route as CouponsNewRouteImport } from './routes/coupons/new'
import { Route as CouponRequestsCampaignIdRouteImport } from './routes/coupon-requests/$campaignId'
import { Route as ConfigurationShippingRouteImport } from './routes/configuration/shipping'
import { Route as ConfigurationReferralRouteImport } from './routes/configuration/referral'
import { Route as ConfigurationPricingRouteImport } from './routes/configuration/pricing'
import { Route as ConfigurationModerationRouteImport } from './routes/configuration/moderation'
import { Route as ConfigurationMcpRouteImport } from './routes/configuration/mcp'
import { Route as ConfigurationInternalPassesRouteImport } from './routes/configuration/internal-passes'
import { Route as ConfigurationDisputesRouteImport } from './routes/configuration/disputes'
import { Route as ConfigurationCrawlRouteImport } from './routes/configuration/crawl'
import { Route as ConfigurationClientVerificationRouteImport } from './routes/configuration/client-verification'
import { Route as ConfigurationCarouselsRouteImport } from './routes/configuration/carousels'
import { Route as ConfigurationApiAccessRouteImport } from './routes/configuration/api-access'
import { Route as CatalogueV2GameSlugRouteImport } from './routes/catalogue-v2/$gameSlug'
import { Route as CardScannerSignatureRunsRouteImport } from './routes/card-scanner/signature-runs'
import { Route as CardScannerModelsRouteImport } from './routes/card-scanner/models'
import { Route as CardScannerManifestRouteImport } from './routes/card-scanner/manifest'
import { Route as CardScannerLabelsRouteImport } from './routes/card-scanner/labels'
import { Route as CardScannerEvalSuitesRouteImport } from './routes/card-scanner/eval-suites'
import { Route as CardScannerEvalJobsRouteImport } from './routes/card-scanner/eval-jobs'
import { Route as BuyerPromotionsNewRouteImport } from './routes/buyer-promotions/new'
import { Route as ApiUsageAdoptionGapsRouteImport } from './routes/api-usage/adoption-gaps'
import { Route as ApiRequestsRequestIdRouteImport } from './routes/api-requests/$requestId'
import { Route as LiveEventsEventIdRouteRouteImport } from './routes/live-events/$eventId/route'
import { Route as UsersUserIdIndexRouteImport } from './routes/users/$userId/index'
import { Route as TransactionsTransactionIdIndexRouteImport } from './routes/transactions/$transactionId/index'
import { Route as ToolsPriceImportsIndexRouteImport } from './routes/tools/price-imports/index'
import { Route as ToolsCrmIndexRouteImport } from './routes/tools/crm/index'
import { Route as SellerPromotionsCampaignIdIndexRouteImport } from './routes/seller-promotions/$campaignId/index'
import { Route as OrdersOrderIdIndexRouteImport } from './routes/orders/$orderId/index'
import { Route as OffersNegotiationIdIndexRouteImport } from './routes/offers/$negotiationId/index'
import { Route as ModerationCaseIdIndexRouteImport } from './routes/moderation/$caseId/index'
import { Route as LiveEventsEventIdIndexRouteImport } from './routes/live-events/$eventId/index'
import { Route as IntegrationAppsPermissionRequestsIndexRouteImport } from './routes/integration-apps/permission-requests/index'
import { Route as IntegrationAppsListingRequestsIndexRouteImport } from './routes/integration-apps/listing-requests/index'
import { Route as IntegrationAppsAppIdIndexRouteImport } from './routes/integration-apps/$appId/index'
import { Route as GamesIdIndexRouteImport } from './routes/games/$id/index'
import { Route as ExpansionGroupsIdIndexRouteImport } from './routes/expansion-groups/$id/index'
import { Route as CouponsProgramsIndexRouteImport } from './routes/coupons/programs/index'
import { Route as CouponsCouponIdIndexRouteImport } from './routes/coupons/$couponId/index'
import { Route as ContestsContestIdIndexRouteImport } from './routes/contests/$contestId/index'
import { Route as CatalogueUpcomingIndexRouteImport } from './routes/catalogue/upcoming/index'
import { Route as CatalogueGamesIndexRouteImport } from './routes/catalogue/games/index'
import { Route as CatalogueFeaturedExpansionsIndexRouteImport } from './routes/catalogue/featured-expansions/index'
import { Route as CatalogueAiMatcherIndexRouteImport } from './routes/catalogue/ai-matcher/index'
import { Route as CatalogueV2ProposalsIndexRouteImport } from './routes/catalogue-v2/proposals/index'
import { Route as BuyerPromotionsPromotionIdIndexRouteImport } from './routes/buyer-promotions/$promotionId/index'
import { Route as AccountingVatRemittancesIndexRouteImport } from './routes/accounting/vat-remittances/index'
import { Route as AccountingVatDeclarationsIndexRouteImport } from './routes/accounting/vat-declarations/index'
import { Route as AccountingReconciliationIndexRouteImport } from './routes/accounting/reconciliation/index'
import { Route as AccountingMonthlyClosesIndexRouteImport } from './routes/accounting/monthly-closes/index'
import { Route as SellerPromotionsCampaignIdEditRouteImport } from './routes/seller-promotions/$campaignId/edit'
import { Route as ProductsSinglesIdRouteImport } from './routes/products/singles/$id'
import { Route as ProductsSealedIdRouteImport } from './routes/products/sealed/$id'
import { Route as LiveEventsEventIdSpinsRouteImport } from './routes/live-events/$eventId/spins'
import { Route as LiveEventsEventIdSettingsRouteImport } from './routes/live-events/$eventId/settings'
import { Route as LiveEventsEventIdParticipantsRouteImport } from './routes/live-events/$eventId/participants'
import { Route as LiveEventsEventIdDrawsRouteImport } from './routes/live-events/$eventId/draws'
import { Route as LiveEventsEventIdBroadcastRouteImport } from './routes/live-events/$eventId/broadcast'
import { Route as LiveEventsEventIdBoothRouteImport } from './routes/live-events/$eventId/booth'
import { Route as IntegrationAppsPermissionRequestsRequestIdRouteImport } from './routes/integration-apps/permission-requests/$requestId'
import { Route as IntegrationAppsListingRequestsProposalIdRouteImport } from './routes/integration-apps/listing-requests/$proposalId'
import { Route as GamesIdManageRouteImport } from './routes/games/$id/manage'
import { Route as ExpansionsIdManageRouteImport } from './routes/expansions/$id/manage'
import { Route as ExpansionGroupsIdManageRouteImport } from './routes/expansion-groups/$id/manage'
import { Route as CouponsProgramsNewRouteImport } from './routes/coupons/programs/new'
import { Route as CouponsCouponIdEditRouteImport } from './routes/coupons/$couponId/edit'
import { Route as CatalogueGamesGameSlugRouteImport } from './routes/catalogue/games/$gameSlug'
import { Route as CatalogueAiMatcherRunIdRouteImport } from './routes/catalogue/ai-matcher/$runId'
import { Route as CatalogueV2ProposalsProposalIdRouteImport } from './routes/catalogue-v2/proposals/$proposalId'
import { Route as CardScannerModelsModelIdRouteImport } from './routes/card-scanner/models_.$modelId'
import { Route as CardScannerJobsJobIdRouteImport } from './routes/card-scanner/jobs.$jobId'
import { Route as CardScannerEvalSuitesSuiteIdRouteImport } from './routes/card-scanner/eval-suites_.$suiteId'
import { Route as CardScannerEvalJobsJobIdRouteImport } from './routes/card-scanner/eval-jobs_.$jobId'
import { Route as BuyerPromotionsPromotionIdEditRouteImport } from './routes/buyer-promotions/$promotionId/edit'
import { Route as AccountingVatDeclarationsDeclarationIdRouteImport } from './routes/accounting/vat-declarations/$declarationId'
import { Route as AccountingMonthlyClosesCloseIdRouteImport } from './routes/accounting/monthly-closes/$closeId'
import { Route as ProductsSinglesIdIndexRouteImport } from './routes/products/singles/$id/index'
import { Route as ProductsSealedIdIndexRouteImport } from './routes/products/sealed/$id/index'
import { Route as CouponsProgramsProgramIdIndexRouteImport } from './routes/coupons/programs/$programId/index'
import { Route as ProductsSinglesIdManageRouteImport } from './routes/products/singles/$id/manage'
import { Route as ProductsSealedIdManageRouteImport } from './routes/products/sealed/$id/manage'
import { Route as CouponsProgramsProgramIdEditRouteImport } from './routes/coupons/programs/$programId/edit'
import { Route as CatalogueGamesGameSlugLocksRouteImport } from './routes/catalogue/games/$gameSlug_.locks'
import { Route as AccountingReconciliationRegionPeriodRouteImport } from './routes/accounting/reconciliation/$region/$period'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteAlertRoute = SiteAlertRouteImport.update({
  id: '/site-alert',
  path: '/site-alert',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IpBansRoute = IpBansRouteImport.update({
  id: '/ip-bans',
  path: '/ip-bans',
  getParentRoute: () => rootRouteImport,
} as any)
const DiffRoute = DiffRouteImport.update({
  id: '/diff',
  path: '/diff',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin-users',
  path: '/admin-users',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRouteRoute = UsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsRouteRoute = TransactionsRouteRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksRouteRoute = TasksRouteRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const ShippingRatesRouteRoute = ShippingRatesRouteRouteImport.update({
  id: '/shipping-rates',
  path: '/shipping-rates',
  getParentRoute: () => rootRouteImport,
} as any)
const SellerPromotionsRouteRoute = SellerPromotionsRouteRouteImport.update({
  id: '/seller-promotions',
  path: '/seller-promotions',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferralsRouteRoute = ReferralsRouteRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRouteRoute = ProductsRouteRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const PostageStampsRouteRoute = PostageStampsRouteRouteImport.update({
  id: '/postage-stamps',
  path: '/postage-stamps',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRouteRoute = OrdersRouteRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const OffersRouteRoute = OffersRouteRouteImport.update({
  id: '/offers',
  path: '/offers',
  getParentRoute: () => rootRouteImport,
} as any)
const ModerationRouteRoute = ModerationRouteRouteImport.update({
  id: '/moderation',
  path: '/moderation',
  getParentRoute: () => rootRouteImport,
} as any)
const LiveEventsRouteRoute = LiveEventsRouteRouteImport.update({
  id: '/live-events',
  path: '/live-events',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationAppsRouteRoute = IntegrationAppsRouteRouteImport.update({
  id: '/integration-apps',
  path: '/integration-apps',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesRouteRoute = GamesRouteRouteImport.update({
  id: '/games',
  path: '/games',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpansionsRouteRoute = ExpansionsRouteRouteImport.update({
  id: '/expansions',
  path: '/expansions',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpansionGroupsRouteRoute = ExpansionGroupsRouteRouteImport.update({
  id: '/expansion-groups',
  path: '/expansion-groups',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatorCodesRouteRoute = CreatorCodesRouteRouteImport.update({
  id: '/creator-codes',
  path: '/creator-codes',
  getParentRoute: () => rootRouteImport,
} as any)
const CrawlRouteRoute = CrawlRouteRouteImport.update({
  id: '/crawl',
  path: '/crawl',
  getParentRoute: () => rootRouteImport,
} as any)
const CouponsRouteRoute = CouponsRouteRouteImport.update({
  id: '/coupons',
  path: '/coupons',
  getParentRoute: () => rootRouteImport,
} as any)
const ContestsRouteRoute = ContestsRouteRouteImport.update({
  id: '/contests',
  path: '/contests',
  getParentRoute: () => rootRouteImport,
} as any)
const BuyerPromotionsRouteRoute = BuyerPromotionsRouteRouteImport.update({
  id: '/buyer-promotions',
  path: '/buyer-promotions',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UsersRouteRoute,
} as any)
const TransactionsIndexRoute = TransactionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TransactionsRouteRoute,
} as any)
const TasksIndexRoute = TasksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TasksRouteRoute,
} as any)
const ShippingRatesIndexRoute = ShippingRatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShippingRatesRouteRoute,
} as any)
const SellerPromotionsIndexRoute = SellerPromotionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SellerPromotionsRouteRoute,
} as any)
const ReviewAppealsIndexRoute = ReviewAppealsIndexRouteImport.update({
  id: '/review-appeals/',
  path: '/review-appeals/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferralsIndexRoute = ReferralsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ReferralsRouteRoute,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductsRouteRoute,
} as any)
const PriceDataAccessIndexRoute = PriceDataAccessIndexRouteImport.update({
  id: '/price-data-access/',
  path: '/price-data-access/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostageStampsIndexRoute = PostageStampsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PostageStampsRouteRoute,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrdersRouteRoute,
} as any)
const OffersIndexRoute = OffersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OffersRouteRoute,
} as any)
const ModerationIndexRoute = ModerationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ModerationRouteRoute,
} as any)
const LiveEventsIndexRoute = LiveEventsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LiveEventsRouteRoute,
} as any)
const IntegrationAppsIndexRoute = IntegrationAppsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => IntegrationAppsRouteRoute,
} as any)
const GamesIndexRoute = GamesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GamesRouteRoute,
} as any)
const ExpansionsIndexRoute = ExpansionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ExpansionsRouteRoute,
} as any)
const ExpansionGroupsIndexRoute = ExpansionGroupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ExpansionGroupsRouteRoute,
} as any)
const DiscordBotIndexRoute = DiscordBotIndexRouteImport.update({
  id: '/discord-bot/',
  path: '/discord-bot/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevToolsIndexRoute = DevToolsIndexRouteImport.update({
  id: '/dev-tools/',
  path: '/dev-tools/',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatorCodesIndexRoute = CreatorCodesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CreatorCodesRouteRoute,
} as any)
const CrawlIndexRoute = CrawlIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CrawlRouteRoute,
} as any)
const CouponsIndexRoute = CouponsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CouponsRouteRoute,
} as any)
const CouponRequestsIndexRoute = CouponRequestsIndexRouteImport.update({
  id: '/coupon-requests/',
  path: '/coupon-requests/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContestsIndexRoute = ContestsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContestsRouteRoute,
} as any)
const CatalogueV2IndexRoute = CatalogueV2IndexRouteImport.update({
  id: '/catalogue-v2/',
  path: '/catalogue-v2/',
  getParentRoute: () => rootRouteImport,
} as any)
const CardScannerIndexRoute = CardScannerIndexRouteImport.update({
  id: '/card-scanner/',
  path: '/card-scanner/',
  getParentRoute: () => rootRouteImport,
} as any)
const BuyerPromotionsIndexRoute = BuyerPromotionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BuyerPromotionsRouteRoute,
} as any)
const ApiUsageIndexRoute = ApiUsageIndexRouteImport.update({
  id: '/api-usage/',
  path: '/api-usage/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiRequestsIndexRoute = ApiRequestsIndexRouteImport.update({
  id: '/api-requests/',
  path: '/api-requests/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountingIndexRoute = AccountingIndexRouteImport.update({
  id: '/accounting/',
  path: '/accounting/',
  getParentRoute: () => rootRouteImport,
} as any)
const TvScreenKeyRoute = TvScreenKeyRouteImport.update({
  id: '/tv/$screenKey',
  path: '/tv/$screenKey',
  getParentRoute: () => rootRouteImport,
} as any)
const SellerPromotionsNewRoute = SellerPromotionsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SellerPromotionsRouteRoute,
} as any)
const ReferralsBatchesRoute = ReferralsBatchesRouteImport.update({
  id: '/batches',
  path: '/batches',
  getParentRoute: () => ReferralsRouteRoute,
} as any)
const PostageStampsSheetIdRoute = PostageStampsSheetIdRouteImport.update({
  id: '/$sheetId',
  path: '/$sheetId',
  getParentRoute: () => PostageStampsRouteRoute,
} as any)
const ModerationIpBansRoute = ModerationIpBansRouteImport.update({
  id: '/ip-bans',
  path: '/ip-bans',
  getParentRoute: () => ModerationRouteRoute,
} as any)
const LiveEventsNewRoute = LiveEventsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => LiveEventsRouteRoute,
} as any)
const IntegrationAppsNewRoute = IntegrationAppsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => IntegrationAppsRouteRoute,
} as any)
const GamesIdRoute = GamesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => GamesRouteRoute,
} as any)
const CrawlSpendingRoute = CrawlSpendingRouteImport.update({
  id: '/spending',
  path: '/spending',
  getParentRoute: () => CrawlRouteRoute,
} as any)
const CrawlSettingsRoute = CrawlSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => CrawlRouteRoute,
} as any)
const CrawlPricesRoute = CrawlPricesRouteImport.update({
  id: '/prices',
  path: '/prices',
  getParentRoute: () => CrawlRouteRoute,
} as any)
const CrawlHealthRoute = CrawlHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => CrawlRouteRoute,
} as any)
const CrawlDataRoute = CrawlDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => CrawlRouteRoute,
} as any)
const CouponsNewRoute = CouponsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => CouponsRouteRoute,
} as any)
const CouponRequestsCampaignIdRoute =
  CouponRequestsCampaignIdRouteImport.update({
    id: '/coupon-requests/$campaignId',
    path: '/coupon-requests/$campaignId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConfigurationShippingRoute = ConfigurationShippingRouteImport.update({
  id: '/configuration/shipping',
  path: '/configuration/shipping',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationReferralRoute = ConfigurationReferralRouteImport.update({
  id: '/configuration/referral',
  path: '/configuration/referral',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationPricingRoute = ConfigurationPricingRouteImport.update({
  id: '/configuration/pricing',
  path: '/configuration/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationModerationRoute = ConfigurationModerationRouteImport.update({
  id: '/configuration/moderation',
  path: '/configuration/moderation',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationMcpRoute = ConfigurationMcpRouteImport.update({
  id: '/configuration/mcp',
  path: '/configuration/mcp',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationInternalPassesRoute =
  ConfigurationInternalPassesRouteImport.update({
    id: '/configuration/internal-passes',
    path: '/configuration/internal-passes',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConfigurationDisputesRoute = ConfigurationDisputesRouteImport.update({
  id: '/configuration/disputes',
  path: '/configuration/disputes',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationCrawlRoute = ConfigurationCrawlRouteImport.update({
  id: '/configuration/crawl',
  path: '/configuration/crawl',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationClientVerificationRoute =
  ConfigurationClientVerificationRouteImport.update({
    id: '/configuration/client-verification',
    path: '/configuration/client-verification',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConfigurationCarouselsRoute = ConfigurationCarouselsRouteImport.update({
  id: '/configuration/carousels',
  path: '/configuration/carousels',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationApiAccessRoute = ConfigurationApiAccessRouteImport.update({
  id: '/configuration/api-access',
  path: '/configuration/api-access',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogueV2GameSlugRoute = CatalogueV2GameSlugRouteImport.update({
  id: '/catalogue-v2/$gameSlug',
  path: '/catalogue-v2/$gameSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const CardScannerSignatureRunsRoute =
  CardScannerSignatureRunsRouteImport.update({
    id: '/card-scanner/signature-runs',
    path: '/card-scanner/signature-runs',
    getParentRoute: () => rootRouteImport,
  } as any)
const CardScannerModelsRoute = CardScannerModelsRouteImport.update({
  id: '/card-scanner/models',
  path: '/card-scanner/models',
  getParentRoute: () => rootRouteImport,
} as any)
const CardScannerManifestRoute = CardScannerManifestRouteImport.update({
  id: '/card-scanner/manifest',
  path: '/card-scanner/manifest',
  getParentRoute: () => rootRouteImport,
} as any)
const CardScannerLabelsRoute = CardScannerLabelsRouteImport.update({
  id: '/card-scanner/labels',
  path: '/card-scanner/labels',
  getParentRoute: () => rootRouteImport,
} as any)
const CardScannerEvalSuitesRoute = CardScannerEvalSuitesRouteImport.update({
  id: '/card-scanner/eval-suites',
  path: '/card-scanner/eval-suites',
  getParentRoute: () => rootRouteImport,
} as any)
const CardScannerEvalJobsRoute = CardScannerEvalJobsRouteImport.update({
  id: '/card-scanner/eval-jobs',
  path: '/card-scanner/eval-jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const BuyerPromotionsNewRoute = BuyerPromotionsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => BuyerPromotionsRouteRoute,
} as any)
const ApiUsageAdoptionGapsRoute = ApiUsageAdoptionGapsRouteImport.update({
  id: '/api-usage/adoption-gaps',
  path: '/api-usage/adoption-gaps',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiRequestsRequestIdRoute = ApiRequestsRequestIdRouteImport.update({
  id: '/api-requests/$requestId',
  path: '/api-requests/$requestId',
  getParentRoute: () => rootRouteImport,
} as any)
const LiveEventsEventIdRouteRoute = LiveEventsEventIdRouteRouteImport.update({
  id: '/$eventId',
  path: '/$eventId',
  getParentRoute: () => LiveEventsRouteRoute,
} as any)
const UsersUserIdIndexRoute = UsersUserIdIndexRouteImport.update({
  id: '/$userId/',
  path: '/$userId/',
  getParentRoute: () => UsersRouteRoute,
} as any)
const TransactionsTransactionIdIndexRoute =
  TransactionsTransactionIdIndexRouteImport.update({
    id: '/$transactionId/',
    path: '/$transactionId/',
    getParentRoute: () => TransactionsRouteRoute,
  } as any)
const ToolsPriceImportsIndexRoute = ToolsPriceImportsIndexRouteImport.update({
  id: '/tools/price-imports/',
  path: '/tools/price-imports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsCrmIndexRoute = ToolsCrmIndexRouteImport.update({
  id: '/tools/crm/',
  path: '/tools/crm/',
  getParentRoute: () => rootRouteImport,
} as any)
const SellerPromotionsCampaignIdIndexRoute =
  SellerPromotionsCampaignIdIndexRouteImport.update({
    id: '/$campaignId/',
    path: '/$campaignId/',
    getParentRoute: () => SellerPromotionsRouteRoute,
  } as any)
const OrdersOrderIdIndexRoute = OrdersOrderIdIndexRouteImport.update({
  id: '/$orderId/',
  path: '/$orderId/',
  getParentRoute: () => OrdersRouteRoute,
} as any)
const OffersNegotiationIdIndexRoute =
  OffersNegotiationIdIndexRouteImport.update({
    id: '/$negotiationId/',
    path: '/$negotiationId/',
    getParentRoute: () => OffersRouteRoute,
  } as any)
const ModerationCaseIdIndexRoute = ModerationCaseIdIndexRouteImport.update({
  id: '/$caseId/',
  path: '/$caseId/',
  getParentRoute: () => ModerationRouteRoute,
} as any)
const LiveEventsEventIdIndexRoute = LiveEventsEventIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LiveEventsEventIdRouteRoute,
} as any)
const IntegrationAppsPermissionRequestsIndexRoute =
  IntegrationAppsPermissionRequestsIndexRouteImport.update({
    id: '/permission-requests/',
    path: '/permission-requests/',
    getParentRoute: () => IntegrationAppsRouteRoute,
  } as any)
const IntegrationAppsListingRequestsIndexRoute =
  IntegrationAppsListingRequestsIndexRouteImport.update({
    id: '/listing-requests/',
    path: '/listing-requests/',
    getParentRoute: () => IntegrationAppsRouteRoute,
  } as any)
const IntegrationAppsAppIdIndexRoute =
  IntegrationAppsAppIdIndexRouteImport.update({
    id: '/$appId/',
    path: '/$appId/',
    getParentRoute: () => IntegrationAppsRouteRoute,
  } as any)
const GamesIdIndexRoute = GamesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GamesIdRoute,
} as any)
const ExpansionGroupsIdIndexRoute = ExpansionGroupsIdIndexRouteImport.update({
  id: '/$id/',
  path: '/$id/',
  getParentRoute: () => ExpansionGroupsRouteRoute,
} as any)
const CouponsProgramsIndexRoute = CouponsProgramsIndexRouteImport.update({
  id: '/programs/',
  path: '/programs/',
  getParentRoute: () => CouponsRouteRoute,
} as any)
const CouponsCouponIdIndexRoute = CouponsCouponIdIndexRouteImport.update({
  id: '/$couponId/',
  path: '/$couponId/',
  getParentRoute: () => CouponsRouteRoute,
} as any)
const ContestsContestIdIndexRoute = ContestsContestIdIndexRouteImport.update({
  id: '/$contestId/',
  path: '/$contestId/',
  getParentRoute: () => ContestsRouteRoute,
} as any)
const CatalogueUpcomingIndexRoute = CatalogueUpcomingIndexRouteImport.update({
  id: '/catalogue/upcoming/',
  path: '/catalogue/upcoming/',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogueGamesIndexRoute = CatalogueGamesIndexRouteImport.update({
  id: '/catalogue/games/',
  path: '/catalogue/games/',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogueFeaturedExpansionsIndexRoute =
  CatalogueFeaturedExpansionsIndexRouteImport.update({
    id: '/catalogue/featured-expansions/',
    path: '/catalogue/featured-expansions/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogueAiMatcherIndexRoute = CatalogueAiMatcherIndexRouteImport.update({
  id: '/catalogue/ai-matcher/',
  path: '/catalogue/ai-matcher/',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogueV2ProposalsIndexRoute =
  CatalogueV2ProposalsIndexRouteImport.update({
    id: '/catalogue-v2/proposals/',
    path: '/catalogue-v2/proposals/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BuyerPromotionsPromotionIdIndexRoute =
  BuyerPromotionsPromotionIdIndexRouteImport.update({
    id: '/$promotionId/',
    path: '/$promotionId/',
    getParentRoute: () => BuyerPromotionsRouteRoute,
  } as any)
const AccountingVatRemittancesIndexRoute =
  AccountingVatRemittancesIndexRouteImport.update({
    id: '/accounting/vat-remittances/',
    path: '/accounting/vat-remittances/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingVatDeclarationsIndexRoute =
  AccountingVatDeclarationsIndexRouteImport.update({
    id: '/accounting/vat-declarations/',
    path: '/accounting/vat-declarations/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingReconciliationIndexRoute =
  AccountingReconciliationIndexRouteImport.update({
    id: '/accounting/reconciliation/',
    path: '/accounting/reconciliation/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingMonthlyClosesIndexRoute =
  AccountingMonthlyClosesIndexRouteImport.update({
    id: '/accounting/monthly-closes/',
    path: '/accounting/monthly-closes/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SellerPromotionsCampaignIdEditRoute =
  SellerPromotionsCampaignIdEditRouteImport.update({
    id: '/$campaignId/edit',
    path: '/$campaignId/edit',
    getParentRoute: () => SellerPromotionsRouteRoute,
  } as any)
const ProductsSinglesIdRoute = ProductsSinglesIdRouteImport.update({
  id: '/singles/$id',
  path: '/singles/$id',
  getParentRoute: () => ProductsRouteRoute,
} as any)
const ProductsSealedIdRoute = ProductsSealedIdRouteImport.update({
  id: '/sealed/$id',
  path: '/sealed/$id',
  getParentRoute: () => ProductsRouteRoute,
} as any)
const LiveEventsEventIdSpinsRoute = LiveEventsEventIdSpinsRouteImport.update({
  id: '/spins',
  path: '/spins',
  getParentRoute: () => LiveEventsEventIdRouteRoute,
} as any)
const LiveEventsEventIdSettingsRoute =
  LiveEventsEventIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => LiveEventsEventIdRouteRoute,
  } as any)
const LiveEventsEventIdParticipantsRoute =
  LiveEventsEventIdParticipantsRouteImport.update({
    id: '/participants',
    path: '/participants',
    getParentRoute: () => LiveEventsEventIdRouteRoute,
  } as any)
const LiveEventsEventIdDrawsRoute = LiveEventsEventIdDrawsRouteImport.update({
  id: '/draws',
  path: '/draws',
  getParentRoute: () => LiveEventsEventIdRouteRoute,
} as any)
const LiveEventsEventIdBroadcastRoute =
  LiveEventsEventIdBroadcastRouteImport.update({
    id: '/broadcast',
    path: '/broadcast',
    getParentRoute: () => LiveEventsEventIdRouteRoute,
  } as any)
const LiveEventsEventIdBoothRoute = LiveEventsEventIdBoothRouteImport.update({
  id: '/booth',
  path: '/booth',
  getParentRoute: () => LiveEventsEventIdRouteRoute,
} as any)
const IntegrationAppsPermissionRequestsRequestIdRoute =
  IntegrationAppsPermissionRequestsRequestIdRouteImport.update({
    id: '/permission-requests/$requestId',
    path: '/permission-requests/$requestId',
    getParentRoute: () => IntegrationAppsRouteRoute,
  } as any)
const IntegrationAppsListingRequestsProposalIdRoute =
  IntegrationAppsListingRequestsProposalIdRouteImport.update({
    id: '/listing-requests/$proposalId',
    path: '/listing-requests/$proposalId',
    getParentRoute: () => IntegrationAppsRouteRoute,
  } as any)
const GamesIdManageRoute = GamesIdManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => GamesIdRoute,
} as any)
const ExpansionsIdManageRoute = ExpansionsIdManageRouteImport.update({
  id: '/$id/manage',
  path: '/$id/manage',
  getParentRoute: () => ExpansionsRouteRoute,
} as any)
const ExpansionGroupsIdManageRoute = ExpansionGroupsIdManageRouteImport.update({
  id: '/$id/manage',
  path: '/$id/manage',
  getParentRoute: () => ExpansionGroupsRouteRoute,
} as any)
const CouponsProgramsNewRoute = CouponsProgramsNewRouteImport.update({
  id: '/programs/new',
  path: '/programs/new',
  getParentRoute: () => CouponsRouteRoute,
} as any)
const CouponsCouponIdEditRoute = CouponsCouponIdEditRouteImport.update({
  id: '/$couponId/edit',
  path: '/$couponId/edit',
  getParentRoute: () => CouponsRouteRoute,
} as any)
const CatalogueGamesGameSlugRoute = CatalogueGamesGameSlugRouteImport.update({
  id: '/catalogue/games/$gameSlug',
  path: '/catalogue/games/$gameSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogueAiMatcherRunIdRoute = CatalogueAiMatcherRunIdRouteImport.update({
  id: '/catalogue/ai-matcher/$runId',
  path: '/catalogue/ai-matcher/$runId',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogueV2ProposalsProposalIdRoute =
  CatalogueV2ProposalsProposalIdRouteImport.update({
    id: '/catalogue-v2/proposals/$proposalId',
    path: '/catalogue-v2/proposals/$proposalId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CardScannerModelsModelIdRoute =
  CardScannerModelsModelIdRouteImport.update({
    id: '/card-scanner/models_/$modelId',
    path: '/card-scanner/models/$modelId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CardScannerJobsJobIdRoute = CardScannerJobsJobIdRouteImport.update({
  id: '/card-scanner/jobs/$jobId',
  path: '/card-scanner/jobs/$jobId',
  getParentRoute: () => rootRouteImport,
} as any)
const CardScannerEvalSuitesSuiteIdRoute =
  CardScannerEvalSuitesSuiteIdRouteImport.update({
    id: '/card-scanner/eval-suites_/$suiteId',
    path: '/card-scanner/eval-suites/$suiteId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CardScannerEvalJobsJobIdRoute =
  CardScannerEvalJobsJobIdRouteImport.update({
    id: '/card-scanner/eval-jobs_/$jobId',
    path: '/card-scanner/eval-jobs/$jobId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BuyerPromotionsPromotionIdEditRoute =
  BuyerPromotionsPromotionIdEditRouteImport.update({
    id: '/$promotionId/edit',
    path: '/$promotionId/edit',
    getParentRoute: () => BuyerPromotionsRouteRoute,
  } as any)
const AccountingVatDeclarationsDeclarationIdRoute =
  AccountingVatDeclarationsDeclarationIdRouteImport.update({
    id: '/accounting/vat-declarations/$declarationId',
    path: '/accounting/vat-declarations/$declarationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingMonthlyClosesCloseIdRoute =
  AccountingMonthlyClosesCloseIdRouteImport.update({
    id: '/accounting/monthly-closes/$closeId',
    path: '/accounting/monthly-closes/$closeId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProductsSinglesIdIndexRoute = ProductsSinglesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductsSinglesIdRoute,
} as any)
const ProductsSealedIdIndexRoute = ProductsSealedIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductsSealedIdRoute,
} as any)
const CouponsProgramsProgramIdIndexRoute =
  CouponsProgramsProgramIdIndexRouteImport.update({
    id: '/programs/$programId/',
    path: '/programs/$programId/',
    getParentRoute: () => CouponsRouteRoute,
  } as any)
const ProductsSinglesIdManageRoute = ProductsSinglesIdManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => ProductsSinglesIdRoute,
} as any)
const ProductsSealedIdManageRoute = ProductsSealedIdManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => ProductsSealedIdRoute,
} as any)
const CouponsProgramsProgramIdEditRoute =
  CouponsProgramsProgramIdEditRouteImport.update({
    id: '/programs/$programId/edit',
    path: '/programs/$programId/edit',
    getParentRoute: () => CouponsRouteRoute,
  } as any)
const CatalogueGamesGameSlugLocksRoute =
  CatalogueGamesGameSlugLocksRouteImport.update({
    id: '/catalogue/games/$gameSlug_/locks',
    path: '/catalogue/games/$gameSlug/locks',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingReconciliationRegionPeriodRoute =
  AccountingReconciliationRegionPeriodRouteImport.update({
    id: '/accounting/reconciliation/$region/$period',
    path: '/accounting/reconciliation/$region/$period',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/buyer-promotions': typeof BuyerPromotionsRouteRouteWithChildren
  '/contests': typeof ContestsRouteRouteWithChildren
  '/coupons': typeof CouponsRouteRouteWithChildren
  '/crawl': typeof CrawlRouteRouteWithChildren
  '/creator-codes': typeof CreatorCodesRouteRouteWithChildren
  '/expansion-groups': typeof ExpansionGroupsRouteRouteWithChildren
  '/expansions': typeof ExpansionsRouteRouteWithChildren
  '/games': typeof GamesRouteRouteWithChildren
  '/integration-apps': typeof IntegrationAppsRouteRouteWithChildren
  '/live-events': typeof LiveEventsRouteRouteWithChildren
  '/moderation': typeof ModerationRouteRouteWithChildren
  '/offers': typeof OffersRouteRouteWithChildren
  '/orders': typeof OrdersRouteRouteWithChildren
  '/postage-stamps': typeof PostageStampsRouteRouteWithChildren
  '/products': typeof ProductsRouteRouteWithChildren
  '/referrals': typeof ReferralsRouteRouteWithChildren
  '/seller-promotions': typeof SellerPromotionsRouteRouteWithChildren
  '/shipping-rates': typeof ShippingRatesRouteRouteWithChildren
  '/tasks': typeof TasksRouteRouteWithChildren
  '/transactions': typeof TransactionsRouteRouteWithChildren
  '/users': typeof UsersRouteRouteWithChildren
  '/admin-users': typeof AdminUsersRoute
  '/diff': typeof DiffRoute
  '/ip-bans': typeof IpBansRoute
  '/login': typeof LoginRoute
  '/site-alert': typeof SiteAlertRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/live-events/$eventId': typeof LiveEventsEventIdRouteRouteWithChildren
  '/api-requests/$requestId': typeof ApiRequestsRequestIdRoute
  '/api-usage/adoption-gaps': typeof ApiUsageAdoptionGapsRoute
  '/buyer-promotions/new': typeof BuyerPromotionsNewRoute
  '/card-scanner/eval-jobs': typeof CardScannerEvalJobsRoute
  '/card-scanner/eval-suites': typeof CardScannerEvalSuitesRoute
  '/card-scanner/labels': typeof CardScannerLabelsRoute
  '/card-scanner/manifest': typeof CardScannerManifestRoute
  '/card-scanner/models': typeof CardScannerModelsRoute
  '/card-scanner/signature-runs': typeof CardScannerSignatureRunsRoute
  '/catalogue-v2/$gameSlug': typeof CatalogueV2GameSlugRoute
  '/configuration/api-access': typeof ConfigurationApiAccessRoute
  '/configuration/carousels': typeof ConfigurationCarouselsRoute
  '/configuration/client-verification': typeof ConfigurationClientVerificationRoute
  '/configuration/crawl': typeof ConfigurationCrawlRoute
  '/configuration/disputes': typeof ConfigurationDisputesRoute
  '/configuration/internal-passes': typeof ConfigurationInternalPassesRoute
  '/configuration/mcp': typeof ConfigurationMcpRoute
  '/configuration/moderation': typeof ConfigurationModerationRoute
  '/configuration/pricing': typeof ConfigurationPricingRoute
  '/configuration/referral': typeof ConfigurationReferralRoute
  '/configuration/shipping': typeof ConfigurationShippingRoute
  '/coupon-requests/$campaignId': typeof CouponRequestsCampaignIdRoute
  '/coupons/new': typeof CouponsNewRoute
  '/crawl/data': typeof CrawlDataRoute
  '/crawl/health': typeof CrawlHealthRoute
  '/crawl/prices': typeof CrawlPricesRoute
  '/crawl/settings': typeof CrawlSettingsRoute
  '/crawl/spending': typeof CrawlSpendingRoute
  '/games/$id': typeof GamesIdRouteWithChildren
  '/integration-apps/new': typeof IntegrationAppsNewRoute
  '/live-events/new': typeof LiveEventsNewRoute
  '/moderation/ip-bans': typeof ModerationIpBansRoute
  '/postage-stamps/$sheetId': typeof PostageStampsSheetIdRoute
  '/referrals/batches': typeof ReferralsBatchesRoute
  '/seller-promotions/new': typeof SellerPromotionsNewRoute
  '/tv/$screenKey': typeof TvScreenKeyRoute
  '/accounting': typeof AccountingIndexRoute
  '/api-requests': typeof ApiRequestsIndexRoute
  '/api-usage': typeof ApiUsageIndexRoute
  '/buyer-promotions/': typeof BuyerPromotionsIndexRoute
  '/card-scanner': typeof CardScannerIndexRoute
  '/catalogue-v2': typeof CatalogueV2IndexRoute
  '/contests/': typeof ContestsIndexRoute
  '/coupon-requests': typeof CouponRequestsIndexRoute
  '/coupons/': typeof CouponsIndexRoute
  '/crawl/': typeof CrawlIndexRoute
  '/creator-codes/': typeof CreatorCodesIndexRoute
  '/dev-tools': typeof DevToolsIndexRoute
  '/discord-bot': typeof DiscordBotIndexRoute
  '/expansion-groups/': typeof ExpansionGroupsIndexRoute
  '/expansions/': typeof ExpansionsIndexRoute
  '/games/': typeof GamesIndexRoute
  '/integration-apps/': typeof IntegrationAppsIndexRoute
  '/live-events/': typeof LiveEventsIndexRoute
  '/moderation/': typeof ModerationIndexRoute
  '/offers/': typeof OffersIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/postage-stamps/': typeof PostageStampsIndexRoute
  '/price-data-access': typeof PriceDataAccessIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/referrals/': typeof ReferralsIndexRoute
  '/review-appeals': typeof ReviewAppealsIndexRoute
  '/seller-promotions/': typeof SellerPromotionsIndexRoute
  '/shipping-rates/': typeof ShippingRatesIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/transactions/': typeof TransactionsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/accounting/monthly-closes/$closeId': typeof AccountingMonthlyClosesCloseIdRoute
  '/accounting/vat-declarations/$declarationId': typeof AccountingVatDeclarationsDeclarationIdRoute
  '/buyer-promotions/$promotionId/edit': typeof BuyerPromotionsPromotionIdEditRoute
  '/card-scanner/eval-jobs/$jobId': typeof CardScannerEvalJobsJobIdRoute
  '/card-scanner/eval-suites/$suiteId': typeof CardScannerEvalSuitesSuiteIdRoute
  '/card-scanner/jobs/$jobId': typeof CardScannerJobsJobIdRoute
  '/card-scanner/models/$modelId': typeof CardScannerModelsModelIdRoute
  '/catalogue-v2/proposals/$proposalId': typeof CatalogueV2ProposalsProposalIdRoute
  '/catalogue/ai-matcher/$runId': typeof CatalogueAiMatcherRunIdRoute
  '/catalogue/games/$gameSlug': typeof CatalogueGamesGameSlugRoute
  '/coupons/$couponId/edit': typeof CouponsCouponIdEditRoute
  '/coupons/programs/new': typeof CouponsProgramsNewRoute
  '/expansion-groups/$id/manage': typeof ExpansionGroupsIdManageRoute
  '/expansions/$id/manage': typeof ExpansionsIdManageRoute
  '/games/$id/manage': typeof GamesIdManageRoute
  '/integration-apps/listing-requests/$proposalId': typeof IntegrationAppsListingRequestsProposalIdRoute
  '/integration-apps/permission-requests/$requestId': typeof IntegrationAppsPermissionRequestsRequestIdRoute
  '/live-events/$eventId/booth': typeof LiveEventsEventIdBoothRoute
  '/live-events/$eventId/broadcast': typeof LiveEventsEventIdBroadcastRoute
  '/live-events/$eventId/draws': typeof LiveEventsEventIdDrawsRoute
  '/live-events/$eventId/participants': typeof LiveEventsEventIdParticipantsRoute
  '/live-events/$eventId/settings': typeof LiveEventsEventIdSettingsRoute
  '/live-events/$eventId/spins': typeof LiveEventsEventIdSpinsRoute
  '/products/sealed/$id': typeof ProductsSealedIdRouteWithChildren
  '/products/singles/$id': typeof ProductsSinglesIdRouteWithChildren
  '/seller-promotions/$campaignId/edit': typeof SellerPromotionsCampaignIdEditRoute
  '/accounting/monthly-closes': typeof AccountingMonthlyClosesIndexRoute
  '/accounting/reconciliation': typeof AccountingReconciliationIndexRoute
  '/accounting/vat-declarations': typeof AccountingVatDeclarationsIndexRoute
  '/accounting/vat-remittances': typeof AccountingVatRemittancesIndexRoute
  '/buyer-promotions/$promotionId': typeof BuyerPromotionsPromotionIdIndexRoute
  '/catalogue-v2/proposals': typeof CatalogueV2ProposalsIndexRoute
  '/catalogue/ai-matcher': typeof CatalogueAiMatcherIndexRoute
  '/catalogue/featured-expansions': typeof CatalogueFeaturedExpansionsIndexRoute
  '/catalogue/games': typeof CatalogueGamesIndexRoute
  '/catalogue/upcoming': typeof CatalogueUpcomingIndexRoute
  '/contests/$contestId': typeof ContestsContestIdIndexRoute
  '/coupons/$couponId': typeof CouponsCouponIdIndexRoute
  '/coupons/programs': typeof CouponsProgramsIndexRoute
  '/expansion-groups/$id': typeof ExpansionGroupsIdIndexRoute
  '/games/$id/': typeof GamesIdIndexRoute
  '/integration-apps/$appId': typeof IntegrationAppsAppIdIndexRoute
  '/integration-apps/listing-requests': typeof IntegrationAppsListingRequestsIndexRoute
  '/integration-apps/permission-requests': typeof IntegrationAppsPermissionRequestsIndexRoute
  '/live-events/$eventId/': typeof LiveEventsEventIdIndexRoute
  '/moderation/$caseId': typeof ModerationCaseIdIndexRoute
  '/offers/$negotiationId': typeof OffersNegotiationIdIndexRoute
  '/orders/$orderId': typeof OrdersOrderIdIndexRoute
  '/seller-promotions/$campaignId': typeof SellerPromotionsCampaignIdIndexRoute
  '/tools/crm': typeof ToolsCrmIndexRoute
  '/tools/price-imports': typeof ToolsPriceImportsIndexRoute
  '/transactions/$transactionId': typeof TransactionsTransactionIdIndexRoute
  '/users/$userId': typeof UsersUserIdIndexRoute
  '/accounting/reconciliation/$region/$period': typeof AccountingReconciliationRegionPeriodRoute
  '/catalogue/games/$gameSlug/locks': typeof CatalogueGamesGameSlugLocksRoute
  '/coupons/programs/$programId/edit': typeof CouponsProgramsProgramIdEditRoute
  '/products/sealed/$id/manage': typeof ProductsSealedIdManageRoute
  '/products/singles/$id/manage': typeof ProductsSinglesIdManageRoute
  '/coupons/programs/$programId': typeof CouponsProgramsProgramIdIndexRoute
  '/products/sealed/$id/': typeof ProductsSealedIdIndexRoute
  '/products/singles/$id/': typeof ProductsSinglesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin-users': typeof AdminUsersRoute
  '/diff': typeof DiffRoute
  '/ip-bans': typeof IpBansRoute
  '/login': typeof LoginRoute
  '/site-alert': typeof SiteAlertRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/api-requests/$requestId': typeof ApiRequestsRequestIdRoute
  '/api-usage/adoption-gaps': typeof ApiUsageAdoptionGapsRoute
  '/buyer-promotions/new': typeof BuyerPromotionsNewRoute
  '/card-scanner/eval-jobs': typeof CardScannerEvalJobsRoute
  '/card-scanner/eval-suites': typeof CardScannerEvalSuitesRoute
  '/card-scanner/labels': typeof CardScannerLabelsRoute
  '/card-scanner/manifest': typeof CardScannerManifestRoute
  '/card-scanner/models': typeof CardScannerModelsRoute
  '/card-scanner/signature-runs': typeof CardScannerSignatureRunsRoute
  '/catalogue-v2/$gameSlug': typeof CatalogueV2GameSlugRoute
  '/configuration/api-access': typeof ConfigurationApiAccessRoute
  '/configuration/carousels': typeof ConfigurationCarouselsRoute
  '/configuration/client-verification': typeof ConfigurationClientVerificationRoute
  '/configuration/crawl': typeof ConfigurationCrawlRoute
  '/configuration/disputes': typeof ConfigurationDisputesRoute
  '/configuration/internal-passes': typeof ConfigurationInternalPassesRoute
  '/configuration/mcp': typeof ConfigurationMcpRoute
  '/configuration/moderation': typeof ConfigurationModerationRoute
  '/configuration/pricing': typeof ConfigurationPricingRoute
  '/configuration/referral': typeof ConfigurationReferralRoute
  '/configuration/shipping': typeof ConfigurationShippingRoute
  '/coupon-requests/$campaignId': typeof CouponRequestsCampaignIdRoute
  '/coupons/new': typeof CouponsNewRoute
  '/crawl/data': typeof CrawlDataRoute
  '/crawl/health': typeof CrawlHealthRoute
  '/crawl/prices': typeof CrawlPricesRoute
  '/crawl/settings': typeof CrawlSettingsRoute
  '/crawl/spending': typeof CrawlSpendingRoute
  '/integration-apps/new': typeof IntegrationAppsNewRoute
  '/live-events/new': typeof LiveEventsNewRoute
  '/moderation/ip-bans': typeof ModerationIpBansRoute
  '/postage-stamps/$sheetId': typeof PostageStampsSheetIdRoute
  '/referrals/batches': typeof ReferralsBatchesRoute
  '/seller-promotions/new': typeof SellerPromotionsNewRoute
  '/tv/$screenKey': typeof TvScreenKeyRoute
  '/accounting': typeof AccountingIndexRoute
  '/api-requests': typeof ApiRequestsIndexRoute
  '/api-usage': typeof ApiUsageIndexRoute
  '/buyer-promotions': typeof BuyerPromotionsIndexRoute
  '/card-scanner': typeof CardScannerIndexRoute
  '/catalogue-v2': typeof CatalogueV2IndexRoute
  '/contests': typeof ContestsIndexRoute
  '/coupon-requests': typeof CouponRequestsIndexRoute
  '/coupons': typeof CouponsIndexRoute
  '/crawl': typeof CrawlIndexRoute
  '/creator-codes': typeof CreatorCodesIndexRoute
  '/dev-tools': typeof DevToolsIndexRoute
  '/discord-bot': typeof DiscordBotIndexRoute
  '/expansion-groups': typeof ExpansionGroupsIndexRoute
  '/expansions': typeof ExpansionsIndexRoute
  '/games': typeof GamesIndexRoute
  '/integration-apps': typeof IntegrationAppsIndexRoute
  '/live-events': typeof LiveEventsIndexRoute
  '/moderation': typeof ModerationIndexRoute
  '/offers': typeof OffersIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/postage-stamps': typeof PostageStampsIndexRoute
  '/price-data-access': typeof PriceDataAccessIndexRoute
  '/products': typeof ProductsIndexRoute
  '/referrals': typeof ReferralsIndexRoute
  '/review-appeals': typeof ReviewAppealsIndexRoute
  '/seller-promotions': typeof SellerPromotionsIndexRoute
  '/shipping-rates': typeof ShippingRatesIndexRoute
  '/tasks': typeof TasksIndexRoute
  '/transactions': typeof TransactionsIndexRoute
  '/users': typeof UsersIndexRoute
  '/accounting/monthly-closes/$closeId': typeof AccountingMonthlyClosesCloseIdRoute
  '/accounting/vat-declarations/$declarationId': typeof AccountingVatDeclarationsDeclarationIdRoute
  '/buyer-promotions/$promotionId/edit': typeof BuyerPromotionsPromotionIdEditRoute
  '/card-scanner/eval-jobs/$jobId': typeof CardScannerEvalJobsJobIdRoute
  '/card-scanner/eval-suites/$suiteId': typeof CardScannerEvalSuitesSuiteIdRoute
  '/card-scanner/jobs/$jobId': typeof CardScannerJobsJobIdRoute
  '/card-scanner/models/$modelId': typeof CardScannerModelsModelIdRoute
  '/catalogue-v2/proposals/$proposalId': typeof CatalogueV2ProposalsProposalIdRoute
  '/catalogue/ai-matcher/$runId': typeof CatalogueAiMatcherRunIdRoute
  '/catalogue/games/$gameSlug': typeof CatalogueGamesGameSlugRoute
  '/coupons/$couponId/edit': typeof CouponsCouponIdEditRoute
  '/coupons/programs/new': typeof CouponsProgramsNewRoute
  '/expansion-groups/$id/manage': typeof ExpansionGroupsIdManageRoute
  '/expansions/$id/manage': typeof ExpansionsIdManageRoute
  '/games/$id/manage': typeof GamesIdManageRoute
  '/integration-apps/listing-requests/$proposalId': typeof IntegrationAppsListingRequestsProposalIdRoute
  '/integration-apps/permission-requests/$requestId': typeof IntegrationAppsPermissionRequestsRequestIdRoute
  '/live-events/$eventId/booth': typeof LiveEventsEventIdBoothRoute
  '/live-events/$eventId/broadcast': typeof LiveEventsEventIdBroadcastRoute
  '/live-events/$eventId/draws': typeof LiveEventsEventIdDrawsRoute
  '/live-events/$eventId/participants': typeof LiveEventsEventIdParticipantsRoute
  '/live-events/$eventId/settings': typeof LiveEventsEventIdSettingsRoute
  '/live-events/$eventId/spins': typeof LiveEventsEventIdSpinsRoute
  '/seller-promotions/$campaignId/edit': typeof SellerPromotionsCampaignIdEditRoute
  '/accounting/monthly-closes': typeof AccountingMonthlyClosesIndexRoute
  '/accounting/reconciliation': typeof AccountingReconciliationIndexRoute
  '/accounting/vat-declarations': typeof AccountingVatDeclarationsIndexRoute
  '/accounting/vat-remittances': typeof AccountingVatRemittancesIndexRoute
  '/buyer-promotions/$promotionId': typeof BuyerPromotionsPromotionIdIndexRoute
  '/catalogue-v2/proposals': typeof CatalogueV2ProposalsIndexRoute
  '/catalogue/ai-matcher': typeof CatalogueAiMatcherIndexRoute
  '/catalogue/featured-expansions': typeof CatalogueFeaturedExpansionsIndexRoute
  '/catalogue/games': typeof CatalogueGamesIndexRoute
  '/catalogue/upcoming': typeof CatalogueUpcomingIndexRoute
  '/contests/$contestId': typeof ContestsContestIdIndexRoute
  '/coupons/$couponId': typeof CouponsCouponIdIndexRoute
  '/coupons/programs': typeof CouponsProgramsIndexRoute
  '/expansion-groups/$id': typeof ExpansionGroupsIdIndexRoute
  '/games/$id': typeof GamesIdIndexRoute
  '/integration-apps/$appId': typeof IntegrationAppsAppIdIndexRoute
  '/integration-apps/listing-requests': typeof IntegrationAppsListingRequestsIndexRoute
  '/integration-apps/permission-requests': typeof IntegrationAppsPermissionRequestsIndexRoute
  '/live-events/$eventId': typeof LiveEventsEventIdIndexRoute
  '/moderation/$caseId': typeof ModerationCaseIdIndexRoute
  '/offers/$negotiationId': typeof OffersNegotiationIdIndexRoute
  '/orders/$orderId': typeof OrdersOrderIdIndexRoute
  '/seller-promotions/$campaignId': typeof SellerPromotionsCampaignIdIndexRoute
  '/tools/crm': typeof ToolsCrmIndexRoute
  '/tools/price-imports': typeof ToolsPriceImportsIndexRoute
  '/transactions/$transactionId': typeof TransactionsTransactionIdIndexRoute
  '/users/$userId': typeof UsersUserIdIndexRoute
  '/accounting/reconciliation/$region/$period': typeof AccountingReconciliationRegionPeriodRoute
  '/catalogue/games/$gameSlug/locks': typeof CatalogueGamesGameSlugLocksRoute
  '/coupons/programs/$programId/edit': typeof CouponsProgramsProgramIdEditRoute
  '/products/sealed/$id/manage': typeof ProductsSealedIdManageRoute
  '/products/singles/$id/manage': typeof ProductsSinglesIdManageRoute
  '/coupons/programs/$programId': typeof CouponsProgramsProgramIdIndexRoute
  '/products/sealed/$id': typeof ProductsSealedIdIndexRoute
  '/products/singles/$id': typeof ProductsSinglesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/buyer-promotions': typeof BuyerPromotionsRouteRouteWithChildren
  '/contests': typeof ContestsRouteRouteWithChildren
  '/coupons': typeof CouponsRouteRouteWithChildren
  '/crawl': typeof CrawlRouteRouteWithChildren
  '/creator-codes': typeof CreatorCodesRouteRouteWithChildren
  '/expansion-groups': typeof ExpansionGroupsRouteRouteWithChildren
  '/expansions': typeof ExpansionsRouteRouteWithChildren
  '/games': typeof GamesRouteRouteWithChildren
  '/integration-apps': typeof IntegrationAppsRouteRouteWithChildren
  '/live-events': typeof LiveEventsRouteRouteWithChildren
  '/moderation': typeof ModerationRouteRouteWithChildren
  '/offers': typeof OffersRouteRouteWithChildren
  '/orders': typeof OrdersRouteRouteWithChildren
  '/postage-stamps': typeof PostageStampsRouteRouteWithChildren
  '/products': typeof ProductsRouteRouteWithChildren
  '/referrals': typeof ReferralsRouteRouteWithChildren
  '/seller-promotions': typeof SellerPromotionsRouteRouteWithChildren
  '/shipping-rates': typeof ShippingRatesRouteRouteWithChildren
  '/tasks': typeof TasksRouteRouteWithChildren
  '/transactions': typeof TransactionsRouteRouteWithChildren
  '/users': typeof UsersRouteRouteWithChildren
  '/admin-users': typeof AdminUsersRoute
  '/diff': typeof DiffRoute
  '/ip-bans': typeof IpBansRoute
  '/login': typeof LoginRoute
  '/site-alert': typeof SiteAlertRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/live-events/$eventId': typeof LiveEventsEventIdRouteRouteWithChildren
  '/api-requests/$requestId': typeof ApiRequestsRequestIdRoute
  '/api-usage/adoption-gaps': typeof ApiUsageAdoptionGapsRoute
  '/buyer-promotions/new': typeof BuyerPromotionsNewRoute
  '/card-scanner/eval-jobs': typeof CardScannerEvalJobsRoute
  '/card-scanner/eval-suites': typeof CardScannerEvalSuitesRoute
  '/card-scanner/labels': typeof CardScannerLabelsRoute
  '/card-scanner/manifest': typeof CardScannerManifestRoute
  '/card-scanner/models': typeof CardScannerModelsRoute
  '/card-scanner/signature-runs': typeof CardScannerSignatureRunsRoute
  '/catalogue-v2/$gameSlug': typeof CatalogueV2GameSlugRoute
  '/configuration/api-access': typeof ConfigurationApiAccessRoute
  '/configuration/carousels': typeof ConfigurationCarouselsRoute
  '/configuration/client-verification': typeof ConfigurationClientVerificationRoute
  '/configuration/crawl': typeof ConfigurationCrawlRoute
  '/configuration/disputes': typeof ConfigurationDisputesRoute
  '/configuration/internal-passes': typeof ConfigurationInternalPassesRoute
  '/configuration/mcp': typeof ConfigurationMcpRoute
  '/configuration/moderation': typeof ConfigurationModerationRoute
  '/configuration/pricing': typeof ConfigurationPricingRoute
  '/configuration/referral': typeof ConfigurationReferralRoute
  '/configuration/shipping': typeof ConfigurationShippingRoute
  '/coupon-requests/$campaignId': typeof CouponRequestsCampaignIdRoute
  '/coupons/new': typeof CouponsNewRoute
  '/crawl/data': typeof CrawlDataRoute
  '/crawl/health': typeof CrawlHealthRoute
  '/crawl/prices': typeof CrawlPricesRoute
  '/crawl/settings': typeof CrawlSettingsRoute
  '/crawl/spending': typeof CrawlSpendingRoute
  '/games/$id': typeof GamesIdRouteWithChildren
  '/integration-apps/new': typeof IntegrationAppsNewRoute
  '/live-events/new': typeof LiveEventsNewRoute
  '/moderation/ip-bans': typeof ModerationIpBansRoute
  '/postage-stamps/$sheetId': typeof PostageStampsSheetIdRoute
  '/referrals/batches': typeof ReferralsBatchesRoute
  '/seller-promotions/new': typeof SellerPromotionsNewRoute
  '/tv/$screenKey': typeof TvScreenKeyRoute
  '/accounting/': typeof AccountingIndexRoute
  '/api-requests/': typeof ApiRequestsIndexRoute
  '/api-usage/': typeof ApiUsageIndexRoute
  '/buyer-promotions/': typeof BuyerPromotionsIndexRoute
  '/card-scanner/': typeof CardScannerIndexRoute
  '/catalogue-v2/': typeof CatalogueV2IndexRoute
  '/contests/': typeof ContestsIndexRoute
  '/coupon-requests/': typeof CouponRequestsIndexRoute
  '/coupons/': typeof CouponsIndexRoute
  '/crawl/': typeof CrawlIndexRoute
  '/creator-codes/': typeof CreatorCodesIndexRoute
  '/dev-tools/': typeof DevToolsIndexRoute
  '/discord-bot/': typeof DiscordBotIndexRoute
  '/expansion-groups/': typeof ExpansionGroupsIndexRoute
  '/expansions/': typeof ExpansionsIndexRoute
  '/games/': typeof GamesIndexRoute
  '/integration-apps/': typeof IntegrationAppsIndexRoute
  '/live-events/': typeof LiveEventsIndexRoute
  '/moderation/': typeof ModerationIndexRoute
  '/offers/': typeof OffersIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/postage-stamps/': typeof PostageStampsIndexRoute
  '/price-data-access/': typeof PriceDataAccessIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/referrals/': typeof ReferralsIndexRoute
  '/review-appeals/': typeof ReviewAppealsIndexRoute
  '/seller-promotions/': typeof SellerPromotionsIndexRoute
  '/shipping-rates/': typeof ShippingRatesIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/transactions/': typeof TransactionsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/accounting/monthly-closes/$closeId': typeof AccountingMonthlyClosesCloseIdRoute
  '/accounting/vat-declarations/$declarationId': typeof AccountingVatDeclarationsDeclarationIdRoute
  '/buyer-promotions/$promotionId/edit': typeof BuyerPromotionsPromotionIdEditRoute
  '/card-scanner/eval-jobs_/$jobId': typeof CardScannerEvalJobsJobIdRoute
  '/card-scanner/eval-suites_/$suiteId': typeof CardScannerEvalSuitesSuiteIdRoute
  '/card-scanner/jobs/$jobId': typeof CardScannerJobsJobIdRoute
  '/card-scanner/models_/$modelId': typeof CardScannerModelsModelIdRoute
  '/catalogue-v2/proposals/$proposalId': typeof CatalogueV2ProposalsProposalIdRoute
  '/catalogue/ai-matcher/$runId': typeof CatalogueAiMatcherRunIdRoute
  '/catalogue/games/$gameSlug': typeof CatalogueGamesGameSlugRoute
  '/coupons/$couponId/edit': typeof CouponsCouponIdEditRoute
  '/coupons/programs/new': typeof CouponsProgramsNewRoute
  '/expansion-groups/$id/manage': typeof ExpansionGroupsIdManageRoute
  '/expansions/$id/manage': typeof ExpansionsIdManageRoute
  '/games/$id/manage': typeof GamesIdManageRoute
  '/integration-apps/listing-requests/$proposalId': typeof IntegrationAppsListingRequestsProposalIdRoute
  '/integration-apps/permission-requests/$requestId': typeof IntegrationAppsPermissionRequestsRequestIdRoute
  '/live-events/$eventId/booth': typeof LiveEventsEventIdBoothRoute
  '/live-events/$eventId/broadcast': typeof LiveEventsEventIdBroadcastRoute
  '/live-events/$eventId/draws': typeof LiveEventsEventIdDrawsRoute
  '/live-events/$eventId/participants': typeof LiveEventsEventIdParticipantsRoute
  '/live-events/$eventId/settings': typeof LiveEventsEventIdSettingsRoute
  '/live-events/$eventId/spins': typeof LiveEventsEventIdSpinsRoute
  '/products/sealed/$id': typeof ProductsSealedIdRouteWithChildren
  '/products/singles/$id': typeof ProductsSinglesIdRouteWithChildren
  '/seller-promotions/$campaignId/edit': typeof SellerPromotionsCampaignIdEditRoute
  '/accounting/monthly-closes/': typeof AccountingMonthlyClosesIndexRoute
  '/accounting/reconciliation/': typeof AccountingReconciliationIndexRoute
  '/accounting/vat-declarations/': typeof AccountingVatDeclarationsIndexRoute
  '/accounting/vat-remittances/': typeof AccountingVatRemittancesIndexRoute
  '/buyer-promotions/$promotionId/': typeof BuyerPromotionsPromotionIdIndexRoute
  '/catalogue-v2/proposals/': typeof CatalogueV2ProposalsIndexRoute
  '/catalogue/ai-matcher/': typeof CatalogueAiMatcherIndexRoute
  '/catalogue/featured-expansions/': typeof CatalogueFeaturedExpansionsIndexRoute
  '/catalogue/games/': typeof CatalogueGamesIndexRoute
  '/catalogue/upcoming/': typeof CatalogueUpcomingIndexRoute
  '/contests/$contestId/': typeof ContestsContestIdIndexRoute
  '/coupons/$couponId/': typeof CouponsCouponIdIndexRoute
  '/coupons/programs/': typeof CouponsProgramsIndexRoute
  '/expansion-groups/$id/': typeof ExpansionGroupsIdIndexRoute
  '/games/$id/': typeof GamesIdIndexRoute
  '/integration-apps/$appId/': typeof IntegrationAppsAppIdIndexRoute
  '/integration-apps/listing-requests/': typeof IntegrationAppsListingRequestsIndexRoute
  '/integration-apps/permission-requests/': typeof IntegrationAppsPermissionRequestsIndexRoute
  '/live-events/$eventId/': typeof LiveEventsEventIdIndexRoute
  '/moderation/$caseId/': typeof ModerationCaseIdIndexRoute
  '/offers/$negotiationId/': typeof OffersNegotiationIdIndexRoute
  '/orders/$orderId/': typeof OrdersOrderIdIndexRoute
  '/seller-promotions/$campaignId/': typeof SellerPromotionsCampaignIdIndexRoute
  '/tools/crm/': typeof ToolsCrmIndexRoute
  '/tools/price-imports/': typeof ToolsPriceImportsIndexRoute
  '/transactions/$transactionId/': typeof TransactionsTransactionIdIndexRoute
  '/users/$userId/': typeof UsersUserIdIndexRoute
  '/accounting/reconciliation/$region/$period': typeof AccountingReconciliationRegionPeriodRoute
  '/catalogue/games/$gameSlug_/locks': typeof CatalogueGamesGameSlugLocksRoute
  '/coupons/programs/$programId/edit': typeof CouponsProgramsProgramIdEditRoute
  '/products/sealed/$id/manage': typeof ProductsSealedIdManageRoute
  '/products/singles/$id/manage': typeof ProductsSinglesIdManageRoute
  '/coupons/programs/$programId/': typeof CouponsProgramsProgramIdIndexRoute
  '/products/sealed/$id/': typeof ProductsSealedIdIndexRoute
  '/products/singles/$id/': typeof ProductsSinglesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/buyer-promotions'
    | '/contests'
    | '/coupons'
    | '/crawl'
    | '/creator-codes'
    | '/expansion-groups'
    | '/expansions'
    | '/games'
    | '/integration-apps'
    | '/live-events'
    | '/moderation'
    | '/offers'
    | '/orders'
    | '/postage-stamps'
    | '/products'
    | '/referrals'
    | '/seller-promotions'
    | '/shipping-rates'
    | '/tasks'
    | '/transactions'
    | '/users'
    | '/admin-users'
    | '/diff'
    | '/ip-bans'
    | '/login'
    | '/site-alert'
    | '/unauthorized'
    | '/live-events/$eventId'
    | '/api-requests/$requestId'
    | '/api-usage/adoption-gaps'
    | '/buyer-promotions/new'
    | '/card-scanner/eval-jobs'
    | '/card-scanner/eval-suites'
    | '/card-scanner/labels'
    | '/card-scanner/manifest'
    | '/card-scanner/models'
    | '/card-scanner/signature-runs'
    | '/catalogue-v2/$gameSlug'
    | '/configuration/api-access'
    | '/configuration/carousels'
    | '/configuration/client-verification'
    | '/configuration/crawl'
    | '/configuration/disputes'
    | '/configuration/internal-passes'
    | '/configuration/mcp'
    | '/configuration/moderation'
    | '/configuration/pricing'
    | '/configuration/referral'
    | '/configuration/shipping'
    | '/coupon-requests/$campaignId'
    | '/coupons/new'
    | '/crawl/data'
    | '/crawl/health'
    | '/crawl/prices'
    | '/crawl/settings'
    | '/crawl/spending'
    | '/games/$id'
    | '/integration-apps/new'
    | '/live-events/new'
    | '/moderation/ip-bans'
    | '/postage-stamps/$sheetId'
    | '/referrals/batches'
    | '/seller-promotions/new'
    | '/tv/$screenKey'
    | '/accounting'
    | '/api-requests'
    | '/api-usage'
    | '/buyer-promotions/'
    | '/card-scanner'
    | '/catalogue-v2'
    | '/contests/'
    | '/coupon-requests'
    | '/coupons/'
    | '/crawl/'
    | '/creator-codes/'
    | '/dev-tools'
    | '/discord-bot'
    | '/expansion-groups/'
    | '/expansions/'
    | '/games/'
    | '/integration-apps/'
    | '/live-events/'
    | '/moderation/'
    | '/offers/'
    | '/orders/'
    | '/postage-stamps/'
    | '/price-data-access'
    | '/products/'
    | '/referrals/'
    | '/review-appeals'
    | '/seller-promotions/'
    | '/shipping-rates/'
    | '/tasks/'
    | '/transactions/'
    | '/users/'
    | '/accounting/monthly-closes/$closeId'
    | '/accounting/vat-declarations/$declarationId'
    | '/buyer-promotions/$promotionId/edit'
    | '/card-scanner/eval-jobs/$jobId'
    | '/card-scanner/eval-suites/$suiteId'
    | '/card-scanner/jobs/$jobId'
    | '/card-scanner/models/$modelId'
    | '/catalogue-v2/proposals/$proposalId'
    | '/catalogue/ai-matcher/$runId'
    | '/catalogue/games/$gameSlug'
    | '/coupons/$couponId/edit'
    | '/coupons/programs/new'
    | '/expansion-groups/$id/manage'
    | '/expansions/$id/manage'
    | '/games/$id/manage'
    | '/integration-apps/listing-requests/$proposalId'
    | '/integration-apps/permission-requests/$requestId'
    | '/live-events/$eventId/booth'
    | '/live-events/$eventId/broadcast'
    | '/live-events/$eventId/draws'
    | '/live-events/$eventId/participants'
    | '/live-events/$eventId/settings'
    | '/live-events/$eventId/spins'
    | '/products/sealed/$id'
    | '/products/singles/$id'
    | '/seller-promotions/$campaignId/edit'
    | '/accounting/monthly-closes'
    | '/accounting/reconciliation'
    | '/accounting/vat-declarations'
    | '/accounting/vat-remittances'
    | '/buyer-promotions/$promotionId'
    | '/catalogue-v2/proposals'
    | '/catalogue/ai-matcher'
    | '/catalogue/featured-expansions'
    | '/catalogue/games'
    | '/catalogue/upcoming'
    | '/contests/$contestId'
    | '/coupons/$couponId'
    | '/coupons/programs'
    | '/expansion-groups/$id'
    | '/games/$id/'
    | '/integration-apps/$appId'
    | '/integration-apps/listing-requests'
    | '/integration-apps/permission-requests'
    | '/live-events/$eventId/'
    | '/moderation/$caseId'
    | '/offers/$negotiationId'
    | '/orders/$orderId'
    | '/seller-promotions/$campaignId'
    | '/tools/crm'
    | '/tools/price-imports'
    | '/transactions/$transactionId'
    | '/users/$userId'
    | '/accounting/reconciliation/$region/$period'
    | '/catalogue/games/$gameSlug/locks'
    | '/coupons/programs/$programId/edit'
    | '/products/sealed/$id/manage'
    | '/products/singles/$id/manage'
    | '/coupons/programs/$programId'
    | '/products/sealed/$id/'
    | '/products/singles/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin-users'
    | '/diff'
    | '/ip-bans'
    | '/login'
    | '/site-alert'
    | '/unauthorized'
    | '/api-requests/$requestId'
    | '/api-usage/adoption-gaps'
    | '/buyer-promotions/new'
    | '/card-scanner/eval-jobs'
    | '/card-scanner/eval-suites'
    | '/card-scanner/labels'
    | '/card-scanner/manifest'
    | '/card-scanner/models'
    | '/card-scanner/signature-runs'
    | '/catalogue-v2/$gameSlug'
    | '/configuration/api-access'
    | '/configuration/carousels'
    | '/configuration/client-verification'
    | '/configuration/crawl'
    | '/configuration/disputes'
    | '/configuration/internal-passes'
    | '/configuration/mcp'
    | '/configuration/moderation'
    | '/configuration/pricing'
    | '/configuration/referral'
    | '/configuration/shipping'
    | '/coupon-requests/$campaignId'
    | '/coupons/new'
    | '/crawl/data'
    | '/crawl/health'
    | '/crawl/prices'
    | '/crawl/settings'
    | '/crawl/spending'
    | '/integration-apps/new'
    | '/live-events/new'
    | '/moderation/ip-bans'
    | '/postage-stamps/$sheetId'
    | '/referrals/batches'
    | '/seller-promotions/new'
    | '/tv/$screenKey'
    | '/accounting'
    | '/api-requests'
    | '/api-usage'
    | '/buyer-promotions'
    | '/card-scanner'
    | '/catalogue-v2'
    | '/contests'
    | '/coupon-requests'
    | '/coupons'
    | '/crawl'
    | '/creator-codes'
    | '/dev-tools'
    | '/discord-bot'
    | '/expansion-groups'
    | '/expansions'
    | '/games'
    | '/integration-apps'
    | '/live-events'
    | '/moderation'
    | '/offers'
    | '/orders'
    | '/postage-stamps'
    | '/price-data-access'
    | '/products'
    | '/referrals'
    | '/review-appeals'
    | '/seller-promotions'
    | '/shipping-rates'
    | '/tasks'
    | '/transactions'
    | '/users'
    | '/accounting/monthly-closes/$closeId'
    | '/accounting/vat-declarations/$declarationId'
    | '/buyer-promotions/$promotionId/edit'
    | '/card-scanner/eval-jobs/$jobId'
    | '/card-scanner/eval-suites/$suiteId'
    | '/card-scanner/jobs/$jobId'
    | '/card-scanner/models/$modelId'
    | '/catalogue-v2/proposals/$proposalId'
    | '/catalogue/ai-matcher/$runId'
    | '/catalogue/games/$gameSlug'
    | '/coupons/$couponId/edit'
    | '/coupons/programs/new'
    | '/expansion-groups/$id/manage'
    | '/expansions/$id/manage'
    | '/games/$id/manage'
    | '/integration-apps/listing-requests/$proposalId'
    | '/integration-apps/permission-requests/$requestId'
    | '/live-events/$eventId/booth'
    | '/live-events/$eventId/broadcast'
    | '/live-events/$eventId/draws'
    | '/live-events/$eventId/participants'
    | '/live-events/$eventId/settings'
    | '/live-events/$eventId/spins'
    | '/seller-promotions/$campaignId/edit'
    | '/accounting/monthly-closes'
    | '/accounting/reconciliation'
    | '/accounting/vat-declarations'
    | '/accounting/vat-remittances'
    | '/buyer-promotions/$promotionId'
    | '/catalogue-v2/proposals'
    | '/catalogue/ai-matcher'
    | '/catalogue/featured-expansions'
    | '/catalogue/games'
    | '/catalogue/upcoming'
    | '/contests/$contestId'
    | '/coupons/$couponId'
    | '/coupons/programs'
    | '/expansion-groups/$id'
    | '/games/$id'
    | '/integration-apps/$appId'
    | '/integration-apps/listing-requests'
    | '/integration-apps/permission-requests'
    | '/live-events/$eventId'
    | '/moderation/$caseId'
    | '/offers/$negotiationId'
    | '/orders/$orderId'
    | '/seller-promotions/$campaignId'
    | '/tools/crm'
    | '/tools/price-imports'
    | '/transactions/$transactionId'
    | '/users/$userId'
    | '/accounting/reconciliation/$region/$period'
    | '/catalogue/games/$gameSlug/locks'
    | '/coupons/programs/$programId/edit'
    | '/products/sealed/$id/manage'
    | '/products/singles/$id/manage'
    | '/coupons/programs/$programId'
    | '/products/sealed/$id'
    | '/products/singles/$id'
  id:
    | '__root__'
    | '/'
    | '/buyer-promotions'
    | '/contests'
    | '/coupons'
    | '/crawl'
    | '/creator-codes'
    | '/expansion-groups'
    | '/expansions'
    | '/games'
    | '/integration-apps'
    | '/live-events'
    | '/moderation'
    | '/offers'
    | '/orders'
    | '/postage-stamps'
    | '/products'
    | '/referrals'
    | '/seller-promotions'
    | '/shipping-rates'
    | '/tasks'
    | '/transactions'
    | '/users'
    | '/admin-users'
    | '/diff'
    | '/ip-bans'
    | '/login'
    | '/site-alert'
    | '/unauthorized'
    | '/live-events/$eventId'
    | '/api-requests/$requestId'
    | '/api-usage/adoption-gaps'
    | '/buyer-promotions/new'
    | '/card-scanner/eval-jobs'
    | '/card-scanner/eval-suites'
    | '/card-scanner/labels'
    | '/card-scanner/manifest'
    | '/card-scanner/models'
    | '/card-scanner/signature-runs'
    | '/catalogue-v2/$gameSlug'
    | '/configuration/api-access'
    | '/configuration/carousels'
    | '/configuration/client-verification'
    | '/configuration/crawl'
    | '/configuration/disputes'
    | '/configuration/internal-passes'
    | '/configuration/mcp'
    | '/configuration/moderation'
    | '/configuration/pricing'
    | '/configuration/referral'
    | '/configuration/shipping'
    | '/coupon-requests/$campaignId'
    | '/coupons/new'
    | '/crawl/data'
    | '/crawl/health'
    | '/crawl/prices'
    | '/crawl/settings'
    | '/crawl/spending'
    | '/games/$id'
    | '/integration-apps/new'
    | '/live-events/new'
    | '/moderation/ip-bans'
    | '/postage-stamps/$sheetId'
    | '/referrals/batches'
    | '/seller-promotions/new'
    | '/tv/$screenKey'
    | '/accounting/'
    | '/api-requests/'
    | '/api-usage/'
    | '/buyer-promotions/'
    | '/card-scanner/'
    | '/catalogue-v2/'
    | '/contests/'
    | '/coupon-requests/'
    | '/coupons/'
    | '/crawl/'
    | '/creator-codes/'
    | '/dev-tools/'
    | '/discord-bot/'
    | '/expansion-groups/'
    | '/expansions/'
    | '/games/'
    | '/integration-apps/'
    | '/live-events/'
    | '/moderation/'
    | '/offers/'
    | '/orders/'
    | '/postage-stamps/'
    | '/price-data-access/'
    | '/products/'
    | '/referrals/'
    | '/review-appeals/'
    | '/seller-promotions/'
    | '/shipping-rates/'
    | '/tasks/'
    | '/transactions/'
    | '/users/'
    | '/accounting/monthly-closes/$closeId'
    | '/accounting/vat-declarations/$declarationId'
    | '/buyer-promotions/$promotionId/edit'
    | '/card-scanner/eval-jobs_/$jobId'
    | '/card-scanner/eval-suites_/$suiteId'
    | '/card-scanner/jobs/$jobId'
    | '/card-scanner/models_/$modelId'
    | '/catalogue-v2/proposals/$proposalId'
    | '/catalogue/ai-matcher/$runId'
    | '/catalogue/games/$gameSlug'
    | '/coupons/$couponId/edit'
    | '/coupons/programs/new'
    | '/expansion-groups/$id/manage'
    | '/expansions/$id/manage'
    | '/games/$id/manage'
    | '/integration-apps/listing-requests/$proposalId'
    | '/integration-apps/permission-requests/$requestId'
    | '/live-events/$eventId/booth'
    | '/live-events/$eventId/broadcast'
    | '/live-events/$eventId/draws'
    | '/live-events/$eventId/participants'
    | '/live-events/$eventId/settings'
    | '/live-events/$eventId/spins'
    | '/products/sealed/$id'
    | '/products/singles/$id'
    | '/seller-promotions/$campaignId/edit'
    | '/accounting/monthly-closes/'
    | '/accounting/reconciliation/'
    | '/accounting/vat-declarations/'
    | '/accounting/vat-remittances/'
    | '/buyer-promotions/$promotionId/'
    | '/catalogue-v2/proposals/'
    | '/catalogue/ai-matcher/'
    | '/catalogue/featured-expansions/'
    | '/catalogue/games/'
    | '/catalogue/upcoming/'
    | '/contests/$contestId/'
    | '/coupons/$couponId/'
    | '/coupons/programs/'
    | '/expansion-groups/$id/'
    | '/games/$id/'
    | '/integration-apps/$appId/'
    | '/integration-apps/listing-requests/'
    | '/integration-apps/permission-requests/'
    | '/live-events/$eventId/'
    | '/moderation/$caseId/'
    | '/offers/$negotiationId/'
    | '/orders/$orderId/'
    | '/seller-promotions/$campaignId/'
    | '/tools/crm/'
    | '/tools/price-imports/'
    | '/transactions/$transactionId/'
    | '/users/$userId/'
    | '/accounting/reconciliation/$region/$period'
    | '/catalogue/games/$gameSlug_/locks'
    | '/coupons/programs/$programId/edit'
    | '/products/sealed/$id/manage'
    | '/products/singles/$id/manage'
    | '/coupons/programs/$programId/'
    | '/products/sealed/$id/'
    | '/products/singles/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BuyerPromotionsRouteRoute: typeof BuyerPromotionsRouteRouteWithChildren
  ContestsRouteRoute: typeof ContestsRouteRouteWithChildren
  CouponsRouteRoute: typeof CouponsRouteRouteWithChildren
  CrawlRouteRoute: typeof CrawlRouteRouteWithChildren
  CreatorCodesRouteRoute: typeof CreatorCodesRouteRouteWithChildren
  ExpansionGroupsRouteRoute: typeof ExpansionGroupsRouteRouteWithChildren
  ExpansionsRouteRoute: typeof ExpansionsRouteRouteWithChildren
  GamesRouteRoute: typeof GamesRouteRouteWithChildren
  IntegrationAppsRouteRoute: typeof IntegrationAppsRouteRouteWithChildren
  LiveEventsRouteRoute: typeof LiveEventsRouteRouteWithChildren
  ModerationRouteRoute: typeof ModerationRouteRouteWithChildren
  OffersRouteRoute: typeof OffersRouteRouteWithChildren
  OrdersRouteRoute: typeof OrdersRouteRouteWithChildren
  PostageStampsRouteRoute: typeof PostageStampsRouteRouteWithChildren
  ProductsRouteRoute: typeof ProductsRouteRouteWithChildren
  ReferralsRouteRoute: typeof ReferralsRouteRouteWithChildren
  SellerPromotionsRouteRoute: typeof SellerPromotionsRouteRouteWithChildren
  ShippingRatesRouteRoute: typeof ShippingRatesRouteRouteWithChildren
  TasksRouteRoute: typeof TasksRouteRouteWithChildren
  TransactionsRouteRoute: typeof TransactionsRouteRouteWithChildren
  UsersRouteRoute: typeof UsersRouteRouteWithChildren
  AdminUsersRoute: typeof AdminUsersRoute
  DiffRoute: typeof DiffRoute
  IpBansRoute: typeof IpBansRoute
  LoginRoute: typeof LoginRoute
  SiteAlertRoute: typeof SiteAlertRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  ApiRequestsRequestIdRoute: typeof ApiRequestsRequestIdRoute
  ApiUsageAdoptionGapsRoute: typeof ApiUsageAdoptionGapsRoute
  CardScannerEvalJobsRoute: typeof CardScannerEvalJobsRoute
  CardScannerEvalSuitesRoute: typeof CardScannerEvalSuitesRoute
  CardScannerLabelsRoute: typeof CardScannerLabelsRoute
  CardScannerManifestRoute: typeof CardScannerManifestRoute
  CardScannerModelsRoute: typeof CardScannerModelsRoute
  CardScannerSignatureRunsRoute: typeof CardScannerSignatureRunsRoute
  CatalogueV2GameSlugRoute: typeof CatalogueV2GameSlugRoute
  ConfigurationApiAccessRoute: typeof ConfigurationApiAccessRoute
  ConfigurationCarouselsRoute: typeof ConfigurationCarouselsRoute
  ConfigurationClientVerificationRoute: typeof ConfigurationClientVerificationRoute
  ConfigurationCrawlRoute: typeof ConfigurationCrawlRoute
  ConfigurationDisputesRoute: typeof ConfigurationDisputesRoute
  ConfigurationInternalPassesRoute: typeof ConfigurationInternalPassesRoute
  ConfigurationMcpRoute: typeof ConfigurationMcpRoute
  ConfigurationModerationRoute: typeof ConfigurationModerationRoute
  ConfigurationPricingRoute: typeof ConfigurationPricingRoute
  ConfigurationReferralRoute: typeof ConfigurationReferralRoute
  ConfigurationShippingRoute: typeof ConfigurationShippingRoute
  CouponRequestsCampaignIdRoute: typeof CouponRequestsCampaignIdRoute
  TvScreenKeyRoute: typeof TvScreenKeyRoute
  AccountingIndexRoute: typeof AccountingIndexRoute
  ApiRequestsIndexRoute: typeof ApiRequestsIndexRoute
  ApiUsageIndexRoute: typeof ApiUsageIndexRoute
  CardScannerIndexRoute: typeof CardScannerIndexRoute
  CatalogueV2IndexRoute: typeof CatalogueV2IndexRoute
  CouponRequestsIndexRoute: typeof CouponRequestsIndexRoute
  DevToolsIndexRoute: typeof DevToolsIndexRoute
  DiscordBotIndexRoute: typeof DiscordBotIndexRoute
  PriceDataAccessIndexRoute: typeof PriceDataAccessIndexRoute
  ReviewAppealsIndexRoute: typeof ReviewAppealsIndexRoute
  AccountingMonthlyClosesCloseIdRoute: typeof AccountingMonthlyClosesCloseIdRoute
  AccountingVatDeclarationsDeclarationIdRoute: typeof AccountingVatDeclarationsDeclarationIdRoute
  CardScannerEvalJobsJobIdRoute: typeof CardScannerEvalJobsJobIdRoute
  CardScannerEvalSuitesSuiteIdRoute: typeof CardScannerEvalSuitesSuiteIdRoute
  CardScannerJobsJobIdRoute: typeof CardScannerJobsJobIdRoute
  CardScannerModelsModelIdRoute: typeof CardScannerModelsModelIdRoute
  CatalogueV2ProposalsProposalIdRoute: typeof CatalogueV2ProposalsProposalIdRoute
  CatalogueAiMatcherRunIdRoute: typeof CatalogueAiMatcherRunIdRoute
  CatalogueGamesGameSlugRoute: typeof CatalogueGamesGameSlugRoute
  AccountingMonthlyClosesIndexRoute: typeof AccountingMonthlyClosesIndexRoute
  AccountingReconciliationIndexRoute: typeof AccountingReconciliationIndexRoute
  AccountingVatDeclarationsIndexRoute: typeof AccountingVatDeclarationsIndexRoute
  AccountingVatRemittancesIndexRoute: typeof AccountingVatRemittancesIndexRoute
  CatalogueV2ProposalsIndexRoute: typeof CatalogueV2ProposalsIndexRoute
  CatalogueAiMatcherIndexRoute: typeof CatalogueAiMatcherIndexRoute
  CatalogueFeaturedExpansionsIndexRoute: typeof CatalogueFeaturedExpansionsIndexRoute
  CatalogueGamesIndexRoute: typeof CatalogueGamesIndexRoute
  CatalogueUpcomingIndexRoute: typeof CatalogueUpcomingIndexRoute
  ToolsCrmIndexRoute: typeof ToolsCrmIndexRoute
  ToolsPriceImportsIndexRoute: typeof ToolsPriceImportsIndexRoute
  AccountingReconciliationRegionPeriodRoute: typeof AccountingReconciliationRegionPeriodRoute
  CatalogueGamesGameSlugLocksRoute: typeof CatalogueGamesGameSlugLocksRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/site-alert': {
      id: '/site-alert'
      path: '/site-alert'
      fullPath: '/site-alert'
      preLoaderRoute: typeof SiteAlertRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ip-bans': {
      id: '/ip-bans'
      path: '/ip-bans'
      fullPath: '/ip-bans'
      preLoaderRoute: typeof IpBansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diff': {
      id: '/diff'
      path: '/diff'
      fullPath: '/diff'
      preLoaderRoute: typeof DiffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-users': {
      id: '/admin-users'
      path: '/admin-users'
      fullPath: '/admin-users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transactions': {
      id: '/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks': {
      id: '/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof TasksRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shipping-rates': {
      id: '/shipping-rates'
      path: '/shipping-rates'
      fullPath: '/shipping-rates'
      preLoaderRoute: typeof ShippingRatesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seller-promotions': {
      id: '/seller-promotions'
      path: '/seller-promotions'
      fullPath: '/seller-promotions'
      preLoaderRoute: typeof SellerPromotionsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referrals': {
      id: '/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof ReferralsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/postage-stamps': {
      id: '/postage-stamps'
      path: '/postage-stamps'
      fullPath: '/postage-stamps'
      preLoaderRoute: typeof PostageStampsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offers': {
      id: '/offers'
      path: '/offers'
      fullPath: '/offers'
      preLoaderRoute: typeof OffersRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/moderation': {
      id: '/moderation'
      path: '/moderation'
      fullPath: '/moderation'
      preLoaderRoute: typeof ModerationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/live-events': {
      id: '/live-events'
      path: '/live-events'
      fullPath: '/live-events'
      preLoaderRoute: typeof LiveEventsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integration-apps': {
      id: '/integration-apps'
      path: '/integration-apps'
      fullPath: '/integration-apps'
      preLoaderRoute: typeof IntegrationAppsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games': {
      id: '/games'
      path: '/games'
      fullPath: '/games'
      preLoaderRoute: typeof GamesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expansions': {
      id: '/expansions'
      path: '/expansions'
      fullPath: '/expansions'
      preLoaderRoute: typeof ExpansionsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expansion-groups': {
      id: '/expansion-groups'
      path: '/expansion-groups'
      fullPath: '/expansion-groups'
      preLoaderRoute: typeof ExpansionGroupsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creator-codes': {
      id: '/creator-codes'
      path: '/creator-codes'
      fullPath: '/creator-codes'
      preLoaderRoute: typeof CreatorCodesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crawl': {
      id: '/crawl'
      path: '/crawl'
      fullPath: '/crawl'
      preLoaderRoute: typeof CrawlRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coupons': {
      id: '/coupons'
      path: '/coupons'
      fullPath: '/coupons'
      preLoaderRoute: typeof CouponsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contests': {
      id: '/contests'
      path: '/contests'
      fullPath: '/contests'
      preLoaderRoute: typeof ContestsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buyer-promotions': {
      id: '/buyer-promotions'
      path: '/buyer-promotions'
      fullPath: '/buyer-promotions'
      preLoaderRoute: typeof BuyerPromotionsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof UsersRouteRoute
    }
    '/transactions/': {
      id: '/transactions/'
      path: '/'
      fullPath: '/transactions/'
      preLoaderRoute: typeof TransactionsIndexRouteImport
      parentRoute: typeof TransactionsRouteRoute
    }
    '/tasks/': {
      id: '/tasks/'
      path: '/'
      fullPath: '/tasks/'
      preLoaderRoute: typeof TasksIndexRouteImport
      parentRoute: typeof TasksRouteRoute
    }
    '/shipping-rates/': {
      id: '/shipping-rates/'
      path: '/'
      fullPath: '/shipping-rates/'
      preLoaderRoute: typeof ShippingRatesIndexRouteImport
      parentRoute: typeof ShippingRatesRouteRoute
    }
    '/seller-promotions/': {
      id: '/seller-promotions/'
      path: '/'
      fullPath: '/seller-promotions/'
      preLoaderRoute: typeof SellerPromotionsIndexRouteImport
      parentRoute: typeof SellerPromotionsRouteRoute
    }
    '/review-appeals/': {
      id: '/review-appeals/'
      path: '/review-appeals'
      fullPath: '/review-appeals'
      preLoaderRoute: typeof ReviewAppealsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referrals/': {
      id: '/referrals/'
      path: '/'
      fullPath: '/referrals/'
      preLoaderRoute: typeof ReferralsIndexRouteImport
      parentRoute: typeof ReferralsRouteRoute
    }
    '/products/': {
      id: '/products/'
      path: '/'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof ProductsRouteRoute
    }
    '/price-data-access/': {
      id: '/price-data-access/'
      path: '/price-data-access'
      fullPath: '/price-data-access'
      preLoaderRoute: typeof PriceDataAccessIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/postage-stamps/': {
      id: '/postage-stamps/'
      path: '/'
      fullPath: '/postage-stamps/'
      preLoaderRoute: typeof PostageStampsIndexRouteImport
      parentRoute: typeof PostageStampsRouteRoute
    }
    '/orders/': {
      id: '/orders/'
      path: '/'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof OrdersRouteRoute
    }
    '/offers/': {
      id: '/offers/'
      path: '/'
      fullPath: '/offers/'
      preLoaderRoute: typeof OffersIndexRouteImport
      parentRoute: typeof OffersRouteRoute
    }
    '/moderation/': {
      id: '/moderation/'
      path: '/'
      fullPath: '/moderation/'
      preLoaderRoute: typeof ModerationIndexRouteImport
      parentRoute: typeof ModerationRouteRoute
    }
    '/live-events/': {
      id: '/live-events/'
      path: '/'
      fullPath: '/live-events/'
      preLoaderRoute: typeof LiveEventsIndexRouteImport
      parentRoute: typeof LiveEventsRouteRoute
    }
    '/integration-apps/': {
      id: '/integration-apps/'
      path: '/'
      fullPath: '/integration-apps/'
      preLoaderRoute: typeof IntegrationAppsIndexRouteImport
      parentRoute: typeof IntegrationAppsRouteRoute
    }
    '/games/': {
      id: '/games/'
      path: '/'
      fullPath: '/games/'
      preLoaderRoute: typeof GamesIndexRouteImport
      parentRoute: typeof GamesRouteRoute
    }
    '/expansions/': {
      id: '/expansions/'
      path: '/'
      fullPath: '/expansions/'
      preLoaderRoute: typeof ExpansionsIndexRouteImport
      parentRoute: typeof ExpansionsRouteRoute
    }
    '/expansion-groups/': {
      id: '/expansion-groups/'
      path: '/'
      fullPath: '/expansion-groups/'
      preLoaderRoute: typeof ExpansionGroupsIndexRouteImport
      parentRoute: typeof ExpansionGroupsRouteRoute
    }
    '/discord-bot/': {
      id: '/discord-bot/'
      path: '/discord-bot'
      fullPath: '/discord-bot'
      preLoaderRoute: typeof DiscordBotIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev-tools/': {
      id: '/dev-tools/'
      path: '/dev-tools'
      fullPath: '/dev-tools'
      preLoaderRoute: typeof DevToolsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creator-codes/': {
      id: '/creator-codes/'
      path: '/'
      fullPath: '/creator-codes/'
      preLoaderRoute: typeof CreatorCodesIndexRouteImport
      parentRoute: typeof CreatorCodesRouteRoute
    }
    '/crawl/': {
      id: '/crawl/'
      path: '/'
      fullPath: '/crawl/'
      preLoaderRoute: typeof CrawlIndexRouteImport
      parentRoute: typeof CrawlRouteRoute
    }
    '/coupons/': {
      id: '/coupons/'
      path: '/'
      fullPath: '/coupons/'
      preLoaderRoute: typeof CouponsIndexRouteImport
      parentRoute: typeof CouponsRouteRoute
    }
    '/coupon-requests/': {
      id: '/coupon-requests/'
      path: '/coupon-requests'
      fullPath: '/coupon-requests'
      preLoaderRoute: typeof CouponRequestsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contests/': {
      id: '/contests/'
      path: '/'
      fullPath: '/contests/'
      preLoaderRoute: typeof ContestsIndexRouteImport
      parentRoute: typeof ContestsRouteRoute
    }
    '/catalogue-v2/': {
      id: '/catalogue-v2/'
      path: '/catalogue-v2'
      fullPath: '/catalogue-v2'
      preLoaderRoute: typeof CatalogueV2IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card-scanner/': {
      id: '/card-scanner/'
      path: '/card-scanner'
      fullPath: '/card-scanner'
      preLoaderRoute: typeof CardScannerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buyer-promotions/': {
      id: '/buyer-promotions/'
      path: '/'
      fullPath: '/buyer-promotions/'
      preLoaderRoute: typeof BuyerPromotionsIndexRouteImport
      parentRoute: typeof BuyerPromotionsRouteRoute
    }
    '/api-usage/': {
      id: '/api-usage/'
      path: '/api-usage'
      fullPath: '/api-usage'
      preLoaderRoute: typeof ApiUsageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-requests/': {
      id: '/api-requests/'
      path: '/api-requests'
      fullPath: '/api-requests'
      preLoaderRoute: typeof ApiRequestsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/': {
      id: '/accounting/'
      path: '/accounting'
      fullPath: '/accounting'
      preLoaderRoute: typeof AccountingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tv/$screenKey': {
      id: '/tv/$screenKey'
      path: '/tv/$screenKey'
      fullPath: '/tv/$screenKey'
      preLoaderRoute: typeof TvScreenKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seller-promotions/new': {
      id: '/seller-promotions/new'
      path: '/new'
      fullPath: '/seller-promotions/new'
      preLoaderRoute: typeof SellerPromotionsNewRouteImport
      parentRoute: typeof SellerPromotionsRouteRoute
    }
    '/referrals/batches': {
      id: '/referrals/batches'
      path: '/batches'
      fullPath: '/referrals/batches'
      preLoaderRoute: typeof ReferralsBatchesRouteImport
      parentRoute: typeof ReferralsRouteRoute
    }
    '/postage-stamps/$sheetId': {
      id: '/postage-stamps/$sheetId'
      path: '/$sheetId'
      fullPath: '/postage-stamps/$sheetId'
      preLoaderRoute: typeof PostageStampsSheetIdRouteImport
      parentRoute: typeof PostageStampsRouteRoute
    }
    '/moderation/ip-bans': {
      id: '/moderation/ip-bans'
      path: '/ip-bans'
      fullPath: '/moderation/ip-bans'
      preLoaderRoute: typeof ModerationIpBansRouteImport
      parentRoute: typeof ModerationRouteRoute
    }
    '/live-events/new': {
      id: '/live-events/new'
      path: '/new'
      fullPath: '/live-events/new'
      preLoaderRoute: typeof LiveEventsNewRouteImport
      parentRoute: typeof LiveEventsRouteRoute
    }
    '/integration-apps/new': {
      id: '/integration-apps/new'
      path: '/new'
      fullPath: '/integration-apps/new'
      preLoaderRoute: typeof IntegrationAppsNewRouteImport
      parentRoute: typeof IntegrationAppsRouteRoute
    }
    '/games/$id': {
      id: '/games/$id'
      path: '/$id'
      fullPath: '/games/$id'
      preLoaderRoute: typeof GamesIdRouteImport
      parentRoute: typeof GamesRouteRoute
    }
    '/crawl/spending': {
      id: '/crawl/spending'
      path: '/spending'
      fullPath: '/crawl/spending'
      preLoaderRoute: typeof CrawlSpendingRouteImport
      parentRoute: typeof CrawlRouteRoute
    }
    '/crawl/settings': {
      id: '/crawl/settings'
      path: '/settings'
      fullPath: '/crawl/settings'
      preLoaderRoute: typeof CrawlSettingsRouteImport
      parentRoute: typeof CrawlRouteRoute
    }
    '/crawl/prices': {
      id: '/crawl/prices'
      path: '/prices'
      fullPath: '/crawl/prices'
      preLoaderRoute: typeof CrawlPricesRouteImport
      parentRoute: typeof CrawlRouteRoute
    }
    '/crawl/health': {
      id: '/crawl/health'
      path: '/health'
      fullPath: '/crawl/health'
      preLoaderRoute: typeof CrawlHealthRouteImport
      parentRoute: typeof CrawlRouteRoute
    }
    '/crawl/data': {
      id: '/crawl/data'
      path: '/data'
      fullPath: '/crawl/data'
      preLoaderRoute: typeof CrawlDataRouteImport
      parentRoute: typeof CrawlRouteRoute
    }
    '/coupons/new': {
      id: '/coupons/new'
      path: '/new'
      fullPath: '/coupons/new'
      preLoaderRoute: typeof CouponsNewRouteImport
      parentRoute: typeof CouponsRouteRoute
    }
    '/coupon-requests/$campaignId': {
      id: '/coupon-requests/$campaignId'
      path: '/coupon-requests/$campaignId'
      fullPath: '/coupon-requests/$campaignId'
      preLoaderRoute: typeof CouponRequestsCampaignIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration/shipping': {
      id: '/configuration/shipping'
      path: '/configuration/shipping'
      fullPath: '/configuration/shipping'
      preLoaderRoute: typeof ConfigurationShippingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration/referral': {
      id: '/configuration/referral'
      path: '/configuration/referral'
      fullPath: '/configuration/referral'
      preLoaderRoute: typeof ConfigurationReferralRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration/pricing': {
      id: '/configuration/pricing'
      path: '/configuration/pricing'
      fullPath: '/configuration/pricing'
      preLoaderRoute: typeof ConfigurationPricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration/moderation': {
      id: '/configuration/moderation'
      path: '/configuration/moderation'
      fullPath: '/configuration/moderation'
      preLoaderRoute: typeof ConfigurationModerationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration/mcp': {
      id: '/configuration/mcp'
      path: '/configuration/mcp'
      fullPath: '/configuration/mcp'
      preLoaderRoute: typeof ConfigurationMcpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration/internal-passes': {
      id: '/configuration/internal-passes'
      path: '/configuration/internal-passes'
      fullPath: '/configuration/internal-passes'
      preLoaderRoute: typeof ConfigurationInternalPassesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration/disputes': {
      id: '/configuration/disputes'
      path: '/configuration/disputes'
      fullPath: '/configuration/disputes'
      preLoaderRoute: typeof ConfigurationDisputesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration/crawl': {
      id: '/configuration/crawl'
      path: '/configuration/crawl'
      fullPath: '/configuration/crawl'
      preLoaderRoute: typeof ConfigurationCrawlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration/client-verification': {
      id: '/configuration/client-verification'
      path: '/configuration/client-verification'
      fullPath: '/configuration/client-verification'
      preLoaderRoute: typeof ConfigurationClientVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration/carousels': {
      id: '/configuration/carousels'
      path: '/configuration/carousels'
      fullPath: '/configuration/carousels'
      preLoaderRoute: typeof ConfigurationCarouselsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration/api-access': {
      id: '/configuration/api-access'
      path: '/configuration/api-access'
      fullPath: '/configuration/api-access'
      preLoaderRoute: typeof ConfigurationApiAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogue-v2/$gameSlug': {
      id: '/catalogue-v2/$gameSlug'
      path: '/catalogue-v2/$gameSlug'
      fullPath: '/catalogue-v2/$gameSlug'
      preLoaderRoute: typeof CatalogueV2GameSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card-scanner/signature-runs': {
      id: '/card-scanner/signature-runs'
      path: '/card-scanner/signature-runs'
      fullPath: '/card-scanner/signature-runs'
      preLoaderRoute: typeof CardScannerSignatureRunsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card-scanner/models': {
      id: '/card-scanner/models'
      path: '/card-scanner/models'
      fullPath: '/card-scanner/models'
      preLoaderRoute: typeof CardScannerModelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card-scanner/manifest': {
      id: '/card-scanner/manifest'
      path: '/card-scanner/manifest'
      fullPath: '/card-scanner/manifest'
      preLoaderRoute: typeof CardScannerManifestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card-scanner/labels': {
      id: '/card-scanner/labels'
      path: '/card-scanner/labels'
      fullPath: '/card-scanner/labels'
      preLoaderRoute: typeof CardScannerLabelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card-scanner/eval-suites': {
      id: '/card-scanner/eval-suites'
      path: '/card-scanner/eval-suites'
      fullPath: '/card-scanner/eval-suites'
      preLoaderRoute: typeof CardScannerEvalSuitesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card-scanner/eval-jobs': {
      id: '/card-scanner/eval-jobs'
      path: '/card-scanner/eval-jobs'
      fullPath: '/card-scanner/eval-jobs'
      preLoaderRoute: typeof CardScannerEvalJobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buyer-promotions/new': {
      id: '/buyer-promotions/new'
      path: '/new'
      fullPath: '/buyer-promotions/new'
      preLoaderRoute: typeof BuyerPromotionsNewRouteImport
      parentRoute: typeof BuyerPromotionsRouteRoute
    }
    '/api-usage/adoption-gaps': {
      id: '/api-usage/adoption-gaps'
      path: '/api-usage/adoption-gaps'
      fullPath: '/api-usage/adoption-gaps'
      preLoaderRoute: typeof ApiUsageAdoptionGapsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-requests/$requestId': {
      id: '/api-requests/$requestId'
      path: '/api-requests/$requestId'
      fullPath: '/api-requests/$requestId'
      preLoaderRoute: typeof ApiRequestsRequestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/live-events/$eventId': {
      id: '/live-events/$eventId'
      path: '/$eventId'
      fullPath: '/live-events/$eventId'
      preLoaderRoute: typeof LiveEventsEventIdRouteRouteImport
      parentRoute: typeof LiveEventsRouteRoute
    }
    '/users/$userId/': {
      id: '/users/$userId/'
      path: '/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof UsersUserIdIndexRouteImport
      parentRoute: typeof UsersRouteRoute
    }
    '/transactions/$transactionId/': {
      id: '/transactions/$transactionId/'
      path: '/$transactionId'
      fullPath: '/transactions/$transactionId'
      preLoaderRoute: typeof TransactionsTransactionIdIndexRouteImport
      parentRoute: typeof TransactionsRouteRoute
    }
    '/tools/price-imports/': {
      id: '/tools/price-imports/'
      path: '/tools/price-imports'
      fullPath: '/tools/price-imports'
      preLoaderRoute: typeof ToolsPriceImportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/crm/': {
      id: '/tools/crm/'
      path: '/tools/crm'
      fullPath: '/tools/crm'
      preLoaderRoute: typeof ToolsCrmIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seller-promotions/$campaignId/': {
      id: '/seller-promotions/$campaignId/'
      path: '/$campaignId'
      fullPath: '/seller-promotions/$campaignId'
      preLoaderRoute: typeof SellerPromotionsCampaignIdIndexRouteImport
      parentRoute: typeof SellerPromotionsRouteRoute
    }
    '/orders/$orderId/': {
      id: '/orders/$orderId/'
      path: '/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof OrdersOrderIdIndexRouteImport
      parentRoute: typeof OrdersRouteRoute
    }
    '/offers/$negotiationId/': {
      id: '/offers/$negotiationId/'
      path: '/$negotiationId'
      fullPath: '/offers/$negotiationId'
      preLoaderRoute: typeof OffersNegotiationIdIndexRouteImport
      parentRoute: typeof OffersRouteRoute
    }
    '/moderation/$caseId/': {
      id: '/moderation/$caseId/'
      path: '/$caseId'
      fullPath: '/moderation/$caseId'
      preLoaderRoute: typeof ModerationCaseIdIndexRouteImport
      parentRoute: typeof ModerationRouteRoute
    }
    '/live-events/$eventId/': {
      id: '/live-events/$eventId/'
      path: '/'
      fullPath: '/live-events/$eventId/'
      preLoaderRoute: typeof LiveEventsEventIdIndexRouteImport
      parentRoute: typeof LiveEventsEventIdRouteRoute
    }
    '/integration-apps/permission-requests/': {
      id: '/integration-apps/permission-requests/'
      path: '/permission-requests'
      fullPath: '/integration-apps/permission-requests'
      preLoaderRoute: typeof IntegrationAppsPermissionRequestsIndexRouteImport
      parentRoute: typeof IntegrationAppsRouteRoute
    }
    '/integration-apps/listing-requests/': {
      id: '/integration-apps/listing-requests/'
      path: '/listing-requests'
      fullPath: '/integration-apps/listing-requests'
      preLoaderRoute: typeof IntegrationAppsListingRequestsIndexRouteImport
      parentRoute: typeof IntegrationAppsRouteRoute
    }
    '/integration-apps/$appId/': {
      id: '/integration-apps/$appId/'
      path: '/$appId'
      fullPath: '/integration-apps/$appId'
      preLoaderRoute: typeof IntegrationAppsAppIdIndexRouteImport
      parentRoute: typeof IntegrationAppsRouteRoute
    }
    '/games/$id/': {
      id: '/games/$id/'
      path: '/'
      fullPath: '/games/$id/'
      preLoaderRoute: typeof GamesIdIndexRouteImport
      parentRoute: typeof GamesIdRoute
    }
    '/expansion-groups/$id/': {
      id: '/expansion-groups/$id/'
      path: '/$id'
      fullPath: '/expansion-groups/$id'
      preLoaderRoute: typeof ExpansionGroupsIdIndexRouteImport
      parentRoute: typeof ExpansionGroupsRouteRoute
    }
    '/coupons/programs/': {
      id: '/coupons/programs/'
      path: '/programs'
      fullPath: '/coupons/programs'
      preLoaderRoute: typeof CouponsProgramsIndexRouteImport
      parentRoute: typeof CouponsRouteRoute
    }
    '/coupons/$couponId/': {
      id: '/coupons/$couponId/'
      path: '/$couponId'
      fullPath: '/coupons/$couponId'
      preLoaderRoute: typeof CouponsCouponIdIndexRouteImport
      parentRoute: typeof CouponsRouteRoute
    }
    '/contests/$contestId/': {
      id: '/contests/$contestId/'
      path: '/$contestId'
      fullPath: '/contests/$contestId'
      preLoaderRoute: typeof ContestsContestIdIndexRouteImport
      parentRoute: typeof ContestsRouteRoute
    }
    '/catalogue/upcoming/': {
      id: '/catalogue/upcoming/'
      path: '/catalogue/upcoming'
      fullPath: '/catalogue/upcoming'
      preLoaderRoute: typeof CatalogueUpcomingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogue/games/': {
      id: '/catalogue/games/'
      path: '/catalogue/games'
      fullPath: '/catalogue/games'
      preLoaderRoute: typeof CatalogueGamesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogue/featured-expansions/': {
      id: '/catalogue/featured-expansions/'
      path: '/catalogue/featured-expansions'
      fullPath: '/catalogue/featured-expansions'
      preLoaderRoute: typeof CatalogueFeaturedExpansionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogue/ai-matcher/': {
      id: '/catalogue/ai-matcher/'
      path: '/catalogue/ai-matcher'
      fullPath: '/catalogue/ai-matcher'
      preLoaderRoute: typeof CatalogueAiMatcherIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogue-v2/proposals/': {
      id: '/catalogue-v2/proposals/'
      path: '/catalogue-v2/proposals'
      fullPath: '/catalogue-v2/proposals'
      preLoaderRoute: typeof CatalogueV2ProposalsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buyer-promotions/$promotionId/': {
      id: '/buyer-promotions/$promotionId/'
      path: '/$promotionId'
      fullPath: '/buyer-promotions/$promotionId'
      preLoaderRoute: typeof BuyerPromotionsPromotionIdIndexRouteImport
      parentRoute: typeof BuyerPromotionsRouteRoute
    }
    '/accounting/vat-remittances/': {
      id: '/accounting/vat-remittances/'
      path: '/accounting/vat-remittances'
      fullPath: '/accounting/vat-remittances'
      preLoaderRoute: typeof AccountingVatRemittancesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/vat-declarations/': {
      id: '/accounting/vat-declarations/'
      path: '/accounting/vat-declarations'
      fullPath: '/accounting/vat-declarations'
      preLoaderRoute: typeof AccountingVatDeclarationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/reconciliation/': {
      id: '/accounting/reconciliation/'
      path: '/accounting/reconciliation'
      fullPath: '/accounting/reconciliation'
      preLoaderRoute: typeof AccountingReconciliationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/monthly-closes/': {
      id: '/accounting/monthly-closes/'
      path: '/accounting/monthly-closes'
      fullPath: '/accounting/monthly-closes'
      preLoaderRoute: typeof AccountingMonthlyClosesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seller-promotions/$campaignId/edit': {
      id: '/seller-promotions/$campaignId/edit'
      path: '/$campaignId/edit'
      fullPath: '/seller-promotions/$campaignId/edit'
      preLoaderRoute: typeof SellerPromotionsCampaignIdEditRouteImport
      parentRoute: typeof SellerPromotionsRouteRoute
    }
    '/products/singles/$id': {
      id: '/products/singles/$id'
      path: '/singles/$id'
      fullPath: '/products/singles/$id'
      preLoaderRoute: typeof ProductsSinglesIdRouteImport
      parentRoute: typeof ProductsRouteRoute
    }
    '/products/sealed/$id': {
      id: '/products/sealed/$id'
      path: '/sealed/$id'
      fullPath: '/products/sealed/$id'
      preLoaderRoute: typeof ProductsSealedIdRouteImport
      parentRoute: typeof ProductsRouteRoute
    }
    '/live-events/$eventId/spins': {
      id: '/live-events/$eventId/spins'
      path: '/spins'
      fullPath: '/live-events/$eventId/spins'
      preLoaderRoute: typeof LiveEventsEventIdSpinsRouteImport
      parentRoute: typeof LiveEventsEventIdRouteRoute
    }
    '/live-events/$eventId/settings': {
      id: '/live-events/$eventId/settings'
      path: '/settings'
      fullPath: '/live-events/$eventId/settings'
      preLoaderRoute: typeof LiveEventsEventIdSettingsRouteImport
      parentRoute: typeof LiveEventsEventIdRouteRoute
    }
    '/live-events/$eventId/participants': {
      id: '/live-events/$eventId/participants'
      path: '/participants'
      fullPath: '/live-events/$eventId/participants'
      preLoaderRoute: typeof LiveEventsEventIdParticipantsRouteImport
      parentRoute: typeof LiveEventsEventIdRouteRoute
    }
    '/live-events/$eventId/draws': {
      id: '/live-events/$eventId/draws'
      path: '/draws'
      fullPath: '/live-events/$eventId/draws'
      preLoaderRoute: typeof LiveEventsEventIdDrawsRouteImport
      parentRoute: typeof LiveEventsEventIdRouteRoute
    }
    '/live-events/$eventId/broadcast': {
      id: '/live-events/$eventId/broadcast'
      path: '/broadcast'
      fullPath: '/live-events/$eventId/broadcast'
      preLoaderRoute: typeof LiveEventsEventIdBroadcastRouteImport
      parentRoute: typeof LiveEventsEventIdRouteRoute
    }
    '/live-events/$eventId/booth': {
      id: '/live-events/$eventId/booth'
      path: '/booth'
      fullPath: '/live-events/$eventId/booth'
      preLoaderRoute: typeof LiveEventsEventIdBoothRouteImport
      parentRoute: typeof LiveEventsEventIdRouteRoute
    }
    '/integration-apps/permission-requests/$requestId': {
      id: '/integration-apps/permission-requests/$requestId'
      path: '/permission-requests/$requestId'
      fullPath: '/integration-apps/permission-requests/$requestId'
      preLoaderRoute: typeof IntegrationAppsPermissionRequestsRequestIdRouteImport
      parentRoute: typeof IntegrationAppsRouteRoute
    }
    '/integration-apps/listing-requests/$proposalId': {
      id: '/integration-apps/listing-requests/$proposalId'
      path: '/listing-requests/$proposalId'
      fullPath: '/integration-apps/listing-requests/$proposalId'
      preLoaderRoute: typeof IntegrationAppsListingRequestsProposalIdRouteImport
      parentRoute: typeof IntegrationAppsRouteRoute
    }
    '/games/$id/manage': {
      id: '/games/$id/manage'
      path: '/manage'
      fullPath: '/games/$id/manage'
      preLoaderRoute: typeof GamesIdManageRouteImport
      parentRoute: typeof GamesIdRoute
    }
    '/expansions/$id/manage': {
      id: '/expansions/$id/manage'
      path: '/$id/manage'
      fullPath: '/expansions/$id/manage'
      preLoaderRoute: typeof ExpansionsIdManageRouteImport
      parentRoute: typeof ExpansionsRouteRoute
    }
    '/expansion-groups/$id/manage': {
      id: '/expansion-groups/$id/manage'
      path: '/$id/manage'
      fullPath: '/expansion-groups/$id/manage'
      preLoaderRoute: typeof ExpansionGroupsIdManageRouteImport
      parentRoute: typeof ExpansionGroupsRouteRoute
    }
    '/coupons/programs/new': {
      id: '/coupons/programs/new'
      path: '/programs/new'
      fullPath: '/coupons/programs/new'
      preLoaderRoute: typeof CouponsProgramsNewRouteImport
      parentRoute: typeof CouponsRouteRoute
    }
    '/coupons/$couponId/edit': {
      id: '/coupons/$couponId/edit'
      path: '/$couponId/edit'
      fullPath: '/coupons/$couponId/edit'
      preLoaderRoute: typeof CouponsCouponIdEditRouteImport
      parentRoute: typeof CouponsRouteRoute
    }
    '/catalogue/games/$gameSlug': {
      id: '/catalogue/games/$gameSlug'
      path: '/catalogue/games/$gameSlug'
      fullPath: '/catalogue/games/$gameSlug'
      preLoaderRoute: typeof CatalogueGamesGameSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogue/ai-matcher/$runId': {
      id: '/catalogue/ai-matcher/$runId'
      path: '/catalogue/ai-matcher/$runId'
      fullPath: '/catalogue/ai-matcher/$runId'
      preLoaderRoute: typeof CatalogueAiMatcherRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogue-v2/proposals/$proposalId': {
      id: '/catalogue-v2/proposals/$proposalId'
      path: '/catalogue-v2/proposals/$proposalId'
      fullPath: '/catalogue-v2/proposals/$proposalId'
      preLoaderRoute: typeof CatalogueV2ProposalsProposalIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card-scanner/models_/$modelId': {
      id: '/card-scanner/models_/$modelId'
      path: '/card-scanner/models/$modelId'
      fullPath: '/card-scanner/models/$modelId'
      preLoaderRoute: typeof CardScannerModelsModelIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card-scanner/jobs/$jobId': {
      id: '/card-scanner/jobs/$jobId'
      path: '/card-scanner/jobs/$jobId'
      fullPath: '/card-scanner/jobs/$jobId'
      preLoaderRoute: typeof CardScannerJobsJobIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card-scanner/eval-suites_/$suiteId': {
      id: '/card-scanner/eval-suites_/$suiteId'
      path: '/card-scanner/eval-suites/$suiteId'
      fullPath: '/card-scanner/eval-suites/$suiteId'
      preLoaderRoute: typeof CardScannerEvalSuitesSuiteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card-scanner/eval-jobs_/$jobId': {
      id: '/card-scanner/eval-jobs_/$jobId'
      path: '/card-scanner/eval-jobs/$jobId'
      fullPath: '/card-scanner/eval-jobs/$jobId'
      preLoaderRoute: typeof CardScannerEvalJobsJobIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buyer-promotions/$promotionId/edit': {
      id: '/buyer-promotions/$promotionId/edit'
      path: '/$promotionId/edit'
      fullPath: '/buyer-promotions/$promotionId/edit'
      preLoaderRoute: typeof BuyerPromotionsPromotionIdEditRouteImport
      parentRoute: typeof BuyerPromotionsRouteRoute
    }
    '/accounting/vat-declarations/$declarationId': {
      id: '/accounting/vat-declarations/$declarationId'
      path: '/accounting/vat-declarations/$declarationId'
      fullPath: '/accounting/vat-declarations/$declarationId'
      preLoaderRoute: typeof AccountingVatDeclarationsDeclarationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/monthly-closes/$closeId': {
      id: '/accounting/monthly-closes/$closeId'
      path: '/accounting/monthly-closes/$closeId'
      fullPath: '/accounting/monthly-closes/$closeId'
      preLoaderRoute: typeof AccountingMonthlyClosesCloseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/singles/$id/': {
      id: '/products/singles/$id/'
      path: '/'
      fullPath: '/products/singles/$id/'
      preLoaderRoute: typeof ProductsSinglesIdIndexRouteImport
      parentRoute: typeof ProductsSinglesIdRoute
    }
    '/products/sealed/$id/': {
      id: '/products/sealed/$id/'
      path: '/'
      fullPath: '/products/sealed/$id/'
      preLoaderRoute: typeof ProductsSealedIdIndexRouteImport
      parentRoute: typeof ProductsSealedIdRoute
    }
    '/coupons/programs/$programId/': {
      id: '/coupons/programs/$programId/'
      path: '/programs/$programId'
      fullPath: '/coupons/programs/$programId'
      preLoaderRoute: typeof CouponsProgramsProgramIdIndexRouteImport
      parentRoute: typeof CouponsRouteRoute
    }
    '/products/singles/$id/manage': {
      id: '/products/singles/$id/manage'
      path: '/manage'
      fullPath: '/products/singles/$id/manage'
      preLoaderRoute: typeof ProductsSinglesIdManageRouteImport
      parentRoute: typeof ProductsSinglesIdRoute
    }
    '/products/sealed/$id/manage': {
      id: '/products/sealed/$id/manage'
      path: '/manage'
      fullPath: '/products/sealed/$id/manage'
      preLoaderRoute: typeof ProductsSealedIdManageRouteImport
      parentRoute: typeof ProductsSealedIdRoute
    }
    '/coupons/programs/$programId/edit': {
      id: '/coupons/programs/$programId/edit'
      path: '/programs/$programId/edit'
      fullPath: '/coupons/programs/$programId/edit'
      preLoaderRoute: typeof CouponsProgramsProgramIdEditRouteImport
      parentRoute: typeof CouponsRouteRoute
    }
    '/catalogue/games/$gameSlug_/locks': {
      id: '/catalogue/games/$gameSlug_/locks'
      path: '/catalogue/games/$gameSlug/locks'
      fullPath: '/catalogue/games/$gameSlug/locks'
      preLoaderRoute: typeof CatalogueGamesGameSlugLocksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/reconciliation/$region/$period': {
      id: '/accounting/reconciliation/$region/$period'
      path: '/accounting/reconciliation/$region/$period'
      fullPath: '/accounting/reconciliation/$region/$period'
      preLoaderRoute: typeof AccountingReconciliationRegionPeriodRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface BuyerPromotionsRouteRouteChildren {
  BuyerPromotionsNewRoute: typeof BuyerPromotionsNewRoute
  BuyerPromotionsIndexRoute: typeof BuyerPromotionsIndexRoute
  BuyerPromotionsPromotionIdEditRoute: typeof BuyerPromotionsPromotionIdEditRoute
  BuyerPromotionsPromotionIdIndexRoute: typeof BuyerPromotionsPromotionIdIndexRoute
}

const BuyerPromotionsRouteRouteChildren: BuyerPromotionsRouteRouteChildren = {
  BuyerPromotionsNewRoute: BuyerPromotionsNewRoute,
  BuyerPromotionsIndexRoute: BuyerPromotionsIndexRoute,
  BuyerPromotionsPromotionIdEditRoute: BuyerPromotionsPromotionIdEditRoute,
  BuyerPromotionsPromotionIdIndexRoute: BuyerPromotionsPromotionIdIndexRoute,
}

const BuyerPromotionsRouteRouteWithChildren =
  BuyerPromotionsRouteRoute._addFileChildren(BuyerPromotionsRouteRouteChildren)

interface ContestsRouteRouteChildren {
  ContestsIndexRoute: typeof ContestsIndexRoute
  ContestsContestIdIndexRoute: typeof ContestsContestIdIndexRoute
}

const ContestsRouteRouteChildren: ContestsRouteRouteChildren = {
  ContestsIndexRoute: ContestsIndexRoute,
  ContestsContestIdIndexRoute: ContestsContestIdIndexRoute,
}

const ContestsRouteRouteWithChildren = ContestsRouteRoute._addFileChildren(
  ContestsRouteRouteChildren,
)

interface CouponsRouteRouteChildren {
  CouponsNewRoute: typeof CouponsNewRoute
  CouponsIndexRoute: typeof CouponsIndexRoute
  CouponsCouponIdEditRoute: typeof CouponsCouponIdEditRoute
  CouponsProgramsNewRoute: typeof CouponsProgramsNewRoute
  CouponsCouponIdIndexRoute: typeof CouponsCouponIdIndexRoute
  CouponsProgramsIndexRoute: typeof CouponsProgramsIndexRoute
  CouponsProgramsProgramIdEditRoute: typeof CouponsProgramsProgramIdEditRoute
  CouponsProgramsProgramIdIndexRoute: typeof CouponsProgramsProgramIdIndexRoute
}

const CouponsRouteRouteChildren: CouponsRouteRouteChildren = {
  CouponsNewRoute: CouponsNewRoute,
  CouponsIndexRoute: CouponsIndexRoute,
  CouponsCouponIdEditRoute: CouponsCouponIdEditRoute,
  CouponsProgramsNewRoute: CouponsProgramsNewRoute,
  CouponsCouponIdIndexRoute: CouponsCouponIdIndexRoute,
  CouponsProgramsIndexRoute: CouponsProgramsIndexRoute,
  CouponsProgramsProgramIdEditRoute: CouponsProgramsProgramIdEditRoute,
  CouponsProgramsProgramIdIndexRoute: CouponsProgramsProgramIdIndexRoute,
}

const CouponsRouteRouteWithChildren = CouponsRouteRoute._addFileChildren(
  CouponsRouteRouteChildren,
)

interface CrawlRouteRouteChildren {
  CrawlDataRoute: typeof CrawlDataRoute
  CrawlHealthRoute: typeof CrawlHealthRoute
  CrawlPricesRoute: typeof CrawlPricesRoute
  CrawlSettingsRoute: typeof CrawlSettingsRoute
  CrawlSpendingRoute: typeof CrawlSpendingRoute
  CrawlIndexRoute: typeof CrawlIndexRoute
}

const CrawlRouteRouteChildren: CrawlRouteRouteChildren = {
  CrawlDataRoute: CrawlDataRoute,
  CrawlHealthRoute: CrawlHealthRoute,
  CrawlPricesRoute: CrawlPricesRoute,
  CrawlSettingsRoute: CrawlSettingsRoute,
  CrawlSpendingRoute: CrawlSpendingRoute,
  CrawlIndexRoute: CrawlIndexRoute,
}

const CrawlRouteRouteWithChildren = CrawlRouteRoute._addFileChildren(
  CrawlRouteRouteChildren,
)

interface CreatorCodesRouteRouteChildren {
  CreatorCodesIndexRoute: typeof CreatorCodesIndexRoute
}

const CreatorCodesRouteRouteChildren: CreatorCodesRouteRouteChildren = {
  CreatorCodesIndexRoute: CreatorCodesIndexRoute,
}

const CreatorCodesRouteRouteWithChildren =
  CreatorCodesRouteRoute._addFileChildren(CreatorCodesRouteRouteChildren)

interface ExpansionGroupsRouteRouteChildren {
  ExpansionGroupsIndexRoute: typeof ExpansionGroupsIndexRoute
  ExpansionGroupsIdManageRoute: typeof ExpansionGroupsIdManageRoute
  ExpansionGroupsIdIndexRoute: typeof ExpansionGroupsIdIndexRoute
}

const ExpansionGroupsRouteRouteChildren: ExpansionGroupsRouteRouteChildren = {
  ExpansionGroupsIndexRoute: ExpansionGroupsIndexRoute,
  ExpansionGroupsIdManageRoute: ExpansionGroupsIdManageRoute,
  ExpansionGroupsIdIndexRoute: ExpansionGroupsIdIndexRoute,
}

const ExpansionGroupsRouteRouteWithChildren =
  ExpansionGroupsRouteRoute._addFileChildren(ExpansionGroupsRouteRouteChildren)

interface ExpansionsRouteRouteChildren {
  ExpansionsIndexRoute: typeof ExpansionsIndexRoute
  ExpansionsIdManageRoute: typeof ExpansionsIdManageRoute
}

const ExpansionsRouteRouteChildren: ExpansionsRouteRouteChildren = {
  ExpansionsIndexRoute: ExpansionsIndexRoute,
  ExpansionsIdManageRoute: ExpansionsIdManageRoute,
}

const ExpansionsRouteRouteWithChildren = ExpansionsRouteRoute._addFileChildren(
  ExpansionsRouteRouteChildren,
)

interface GamesIdRouteChildren {
  GamesIdManageRoute: typeof GamesIdManageRoute
  GamesIdIndexRoute: typeof GamesIdIndexRoute
}

const GamesIdRouteChildren: GamesIdRouteChildren = {
  GamesIdManageRoute: GamesIdManageRoute,
  GamesIdIndexRoute: GamesIdIndexRoute,
}

const GamesIdRouteWithChildren =
  GamesIdRoute._addFileChildren(GamesIdRouteChildren)

interface GamesRouteRouteChildren {
  GamesIdRoute: typeof GamesIdRouteWithChildren
  GamesIndexRoute: typeof GamesIndexRoute
}

const GamesRouteRouteChildren: GamesRouteRouteChildren = {
  GamesIdRoute: GamesIdRouteWithChildren,
  GamesIndexRoute: GamesIndexRoute,
}

const GamesRouteRouteWithChildren = GamesRouteRoute._addFileChildren(
  GamesRouteRouteChildren,
)

interface IntegrationAppsRouteRouteChildren {
  IntegrationAppsNewRoute: typeof IntegrationAppsNewRoute
  IntegrationAppsIndexRoute: typeof IntegrationAppsIndexRoute
  IntegrationAppsListingRequestsProposalIdRoute: typeof IntegrationAppsListingRequestsProposalIdRoute
  IntegrationAppsPermissionRequestsRequestIdRoute: typeof IntegrationAppsPermissionRequestsRequestIdRoute
  IntegrationAppsAppIdIndexRoute: typeof IntegrationAppsAppIdIndexRoute
  IntegrationAppsListingRequestsIndexRoute: typeof IntegrationAppsListingRequestsIndexRoute
  IntegrationAppsPermissionRequestsIndexRoute: typeof IntegrationAppsPermissionRequestsIndexRoute
}

const IntegrationAppsRouteRouteChildren: IntegrationAppsRouteRouteChildren = {
  IntegrationAppsNewRoute: IntegrationAppsNewRoute,
  IntegrationAppsIndexRoute: IntegrationAppsIndexRoute,
  IntegrationAppsListingRequestsProposalIdRoute:
    IntegrationAppsListingRequestsProposalIdRoute,
  IntegrationAppsPermissionRequestsRequestIdRoute:
    IntegrationAppsPermissionRequestsRequestIdRoute,
  IntegrationAppsAppIdIndexRoute: IntegrationAppsAppIdIndexRoute,
  IntegrationAppsListingRequestsIndexRoute:
    IntegrationAppsListingRequestsIndexRoute,
  IntegrationAppsPermissionRequestsIndexRoute:
    IntegrationAppsPermissionRequestsIndexRoute,
}

const IntegrationAppsRouteRouteWithChildren =
  IntegrationAppsRouteRoute._addFileChildren(IntegrationAppsRouteRouteChildren)

interface LiveEventsEventIdRouteRouteChildren {
  LiveEventsEventIdBoothRoute: typeof LiveEventsEventIdBoothRoute
  LiveEventsEventIdBroadcastRoute: typeof LiveEventsEventIdBroadcastRoute
  LiveEventsEventIdDrawsRoute: typeof LiveEventsEventIdDrawsRoute
  LiveEventsEventIdParticipantsRoute: typeof LiveEventsEventIdParticipantsRoute
  LiveEventsEventIdSettingsRoute: typeof LiveEventsEventIdSettingsRoute
  LiveEventsEventIdSpinsRoute: typeof LiveEventsEventIdSpinsRoute
  LiveEventsEventIdIndexRoute: typeof LiveEventsEventIdIndexRoute
}

const LiveEventsEventIdRouteRouteChildren: LiveEventsEventIdRouteRouteChildren =
  {
    LiveEventsEventIdBoothRoute: LiveEventsEventIdBoothRoute,
    LiveEventsEventIdBroadcastRoute: LiveEventsEventIdBroadcastRoute,
    LiveEventsEventIdDrawsRoute: LiveEventsEventIdDrawsRoute,
    LiveEventsEventIdParticipantsRoute: LiveEventsEventIdParticipantsRoute,
    LiveEventsEventIdSettingsRoute: LiveEventsEventIdSettingsRoute,
    LiveEventsEventIdSpinsRoute: LiveEventsEventIdSpinsRoute,
    LiveEventsEventIdIndexRoute: LiveEventsEventIdIndexRoute,
  }

const LiveEventsEventIdRouteRouteWithChildren =
  LiveEventsEventIdRouteRoute._addFileChildren(
    LiveEventsEventIdRouteRouteChildren,
  )

interface LiveEventsRouteRouteChildren {
  LiveEventsEventIdRouteRoute: typeof LiveEventsEventIdRouteRouteWithChildren
  LiveEventsNewRoute: typeof LiveEventsNewRoute
  LiveEventsIndexRoute: typeof LiveEventsIndexRoute
}

const LiveEventsRouteRouteChildren: LiveEventsRouteRouteChildren = {
  LiveEventsEventIdRouteRoute: LiveEventsEventIdRouteRouteWithChildren,
  LiveEventsNewRoute: LiveEventsNewRoute,
  LiveEventsIndexRoute: LiveEventsIndexRoute,
}

const LiveEventsRouteRouteWithChildren = LiveEventsRouteRoute._addFileChildren(
  LiveEventsRouteRouteChildren,
)

interface ModerationRouteRouteChildren {
  ModerationIpBansRoute: typeof ModerationIpBansRoute
  ModerationIndexRoute: typeof ModerationIndexRoute
  ModerationCaseIdIndexRoute: typeof ModerationCaseIdIndexRoute
}

const ModerationRouteRouteChildren: ModerationRouteRouteChildren = {
  ModerationIpBansRoute: ModerationIpBansRoute,
  ModerationIndexRoute: ModerationIndexRoute,
  ModerationCaseIdIndexRoute: ModerationCaseIdIndexRoute,
}

const ModerationRouteRouteWithChildren = ModerationRouteRoute._addFileChildren(
  ModerationRouteRouteChildren,
)

interface OffersRouteRouteChildren {
  OffersIndexRoute: typeof OffersIndexRoute
  OffersNegotiationIdIndexRoute: typeof OffersNegotiationIdIndexRoute
}

const OffersRouteRouteChildren: OffersRouteRouteChildren = {
  OffersIndexRoute: OffersIndexRoute,
  OffersNegotiationIdIndexRoute: OffersNegotiationIdIndexRoute,
}

const OffersRouteRouteWithChildren = OffersRouteRoute._addFileChildren(
  OffersRouteRouteChildren,
)

interface OrdersRouteRouteChildren {
  OrdersIndexRoute: typeof OrdersIndexRoute
  OrdersOrderIdIndexRoute: typeof OrdersOrderIdIndexRoute
}

const OrdersRouteRouteChildren: OrdersRouteRouteChildren = {
  OrdersIndexRoute: OrdersIndexRoute,
  OrdersOrderIdIndexRoute: OrdersOrderIdIndexRoute,
}

const OrdersRouteRouteWithChildren = OrdersRouteRoute._addFileChildren(
  OrdersRouteRouteChildren,
)

interface PostageStampsRouteRouteChildren {
  PostageStampsSheetIdRoute: typeof PostageStampsSheetIdRoute
  PostageStampsIndexRoute: typeof PostageStampsIndexRoute
}

const PostageStampsRouteRouteChildren: PostageStampsRouteRouteChildren = {
  PostageStampsSheetIdRoute: PostageStampsSheetIdRoute,
  PostageStampsIndexRoute: PostageStampsIndexRoute,
}

const PostageStampsRouteRouteWithChildren =
  PostageStampsRouteRoute._addFileChildren(PostageStampsRouteRouteChildren)

interface ProductsSealedIdRouteChildren {
  ProductsSealedIdManageRoute: typeof ProductsSealedIdManageRoute
  ProductsSealedIdIndexRoute: typeof ProductsSealedIdIndexRoute
}

const ProductsSealedIdRouteChildren: ProductsSealedIdRouteChildren = {
  ProductsSealedIdManageRoute: ProductsSealedIdManageRoute,
  ProductsSealedIdIndexRoute: ProductsSealedIdIndexRoute,
}

const ProductsSealedIdRouteWithChildren =
  ProductsSealedIdRoute._addFileChildren(ProductsSealedIdRouteChildren)

interface ProductsSinglesIdRouteChildren {
  ProductsSinglesIdManageRoute: typeof ProductsSinglesIdManageRoute
  ProductsSinglesIdIndexRoute: typeof ProductsSinglesIdIndexRoute
}

const ProductsSinglesIdRouteChildren: ProductsSinglesIdRouteChildren = {
  ProductsSinglesIdManageRoute: ProductsSinglesIdManageRoute,
  ProductsSinglesIdIndexRoute: ProductsSinglesIdIndexRoute,
}

const ProductsSinglesIdRouteWithChildren =
  ProductsSinglesIdRoute._addFileChildren(ProductsSinglesIdRouteChildren)

interface ProductsRouteRouteChildren {
  ProductsIndexRoute: typeof ProductsIndexRoute
  ProductsSealedIdRoute: typeof ProductsSealedIdRouteWithChildren
  ProductsSinglesIdRoute: typeof ProductsSinglesIdRouteWithChildren
}

const ProductsRouteRouteChildren: ProductsRouteRouteChildren = {
  ProductsIndexRoute: ProductsIndexRoute,
  ProductsSealedIdRoute: ProductsSealedIdRouteWithChildren,
  ProductsSinglesIdRoute: ProductsSinglesIdRouteWithChildren,
}

const ProductsRouteRouteWithChildren = ProductsRouteRoute._addFileChildren(
  ProductsRouteRouteChildren,
)

interface ReferralsRouteRouteChildren {
  ReferralsBatchesRoute: typeof ReferralsBatchesRoute
  ReferralsIndexRoute: typeof ReferralsIndexRoute
}

const ReferralsRouteRouteChildren: ReferralsRouteRouteChildren = {
  ReferralsBatchesRoute: ReferralsBatchesRoute,
  ReferralsIndexRoute: ReferralsIndexRoute,
}

const ReferralsRouteRouteWithChildren = ReferralsRouteRoute._addFileChildren(
  ReferralsRouteRouteChildren,
)

interface SellerPromotionsRouteRouteChildren {
  SellerPromotionsNewRoute: typeof SellerPromotionsNewRoute
  SellerPromotionsIndexRoute: typeof SellerPromotionsIndexRoute
  SellerPromotionsCampaignIdEditRoute: typeof SellerPromotionsCampaignIdEditRoute
  SellerPromotionsCampaignIdIndexRoute: typeof SellerPromotionsCampaignIdIndexRoute
}

const SellerPromotionsRouteRouteChildren: SellerPromotionsRouteRouteChildren = {
  SellerPromotionsNewRoute: SellerPromotionsNewRoute,
  SellerPromotionsIndexRoute: SellerPromotionsIndexRoute,
  SellerPromotionsCampaignIdEditRoute: SellerPromotionsCampaignIdEditRoute,
  SellerPromotionsCampaignIdIndexRoute: SellerPromotionsCampaignIdIndexRoute,
}

const SellerPromotionsRouteRouteWithChildren =
  SellerPromotionsRouteRoute._addFileChildren(
    SellerPromotionsRouteRouteChildren,
  )

interface ShippingRatesRouteRouteChildren {
  ShippingRatesIndexRoute: typeof ShippingRatesIndexRoute
}

const ShippingRatesRouteRouteChildren: ShippingRatesRouteRouteChildren = {
  ShippingRatesIndexRoute: ShippingRatesIndexRoute,
}

const ShippingRatesRouteRouteWithChildren =
  ShippingRatesRouteRoute._addFileChildren(ShippingRatesRouteRouteChildren)

interface TasksRouteRouteChildren {
  TasksIndexRoute: typeof TasksIndexRoute
}

const TasksRouteRouteChildren: TasksRouteRouteChildren = {
  TasksIndexRoute: TasksIndexRoute,
}

const TasksRouteRouteWithChildren = TasksRouteRoute._addFileChildren(
  TasksRouteRouteChildren,
)

interface TransactionsRouteRouteChildren {
  TransactionsIndexRoute: typeof TransactionsIndexRoute
  TransactionsTransactionIdIndexRoute: typeof TransactionsTransactionIdIndexRoute
}

const TransactionsRouteRouteChildren: TransactionsRouteRouteChildren = {
  TransactionsIndexRoute: TransactionsIndexRoute,
  TransactionsTransactionIdIndexRoute: TransactionsTransactionIdIndexRoute,
}

const TransactionsRouteRouteWithChildren =
  TransactionsRouteRoute._addFileChildren(TransactionsRouteRouteChildren)

interface UsersRouteRouteChildren {
  UsersIndexRoute: typeof UsersIndexRoute
  UsersUserIdIndexRoute: typeof UsersUserIdIndexRoute
}

const UsersRouteRouteChildren: UsersRouteRouteChildren = {
  UsersIndexRoute: UsersIndexRoute,
  UsersUserIdIndexRoute: UsersUserIdIndexRoute,
}

const UsersRouteRouteWithChildren = UsersRouteRoute._addFileChildren(
  UsersRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BuyerPromotionsRouteRoute: BuyerPromotionsRouteRouteWithChildren,
  ContestsRouteRoute: ContestsRouteRouteWithChildren,
  CouponsRouteRoute: CouponsRouteRouteWithChildren,
  CrawlRouteRoute: CrawlRouteRouteWithChildren,
  CreatorCodesRouteRoute: CreatorCodesRouteRouteWithChildren,
  ExpansionGroupsRouteRoute: ExpansionGroupsRouteRouteWithChildren,
  ExpansionsRouteRoute: ExpansionsRouteRouteWithChildren,
  GamesRouteRoute: GamesRouteRouteWithChildren,
  IntegrationAppsRouteRoute: IntegrationAppsRouteRouteWithChildren,
  LiveEventsRouteRoute: LiveEventsRouteRouteWithChildren,
  ModerationRouteRoute: ModerationRouteRouteWithChildren,
  OffersRouteRoute: OffersRouteRouteWithChildren,
  OrdersRouteRoute: OrdersRouteRouteWithChildren,
  PostageStampsRouteRoute: PostageStampsRouteRouteWithChildren,
  ProductsRouteRoute: ProductsRouteRouteWithChildren,
  ReferralsRouteRoute: ReferralsRouteRouteWithChildren,
  SellerPromotionsRouteRoute: SellerPromotionsRouteRouteWithChildren,
  ShippingRatesRouteRoute: ShippingRatesRouteRouteWithChildren,
  TasksRouteRoute: TasksRouteRouteWithChildren,
  TransactionsRouteRoute: TransactionsRouteRouteWithChildren,
  UsersRouteRoute: UsersRouteRouteWithChildren,
  AdminUsersRoute: AdminUsersRoute,
  DiffRoute: DiffRoute,
  IpBansRoute: IpBansRoute,
  LoginRoute: LoginRoute,
  SiteAlertRoute: SiteAlertRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  ApiRequestsRequestIdRoute: ApiRequestsRequestIdRoute,
  ApiUsageAdoptionGapsRoute: ApiUsageAdoptionGapsRoute,
  CardScannerEvalJobsRoute: CardScannerEvalJobsRoute,
  CardScannerEvalSuitesRoute: CardScannerEvalSuitesRoute,
  CardScannerLabelsRoute: CardScannerLabelsRoute,
  CardScannerManifestRoute: CardScannerManifestRoute,
  CardScannerModelsRoute: CardScannerModelsRoute,
  CardScannerSignatureRunsRoute: CardScannerSignatureRunsRoute,
  CatalogueV2GameSlugRoute: CatalogueV2GameSlugRoute,
  ConfigurationApiAccessRoute: ConfigurationApiAccessRoute,
  ConfigurationCarouselsRoute: ConfigurationCarouselsRoute,
  ConfigurationClientVerificationRoute: ConfigurationClientVerificationRoute,
  ConfigurationCrawlRoute: ConfigurationCrawlRoute,
  ConfigurationDisputesRoute: ConfigurationDisputesRoute,
  ConfigurationInternalPassesRoute: ConfigurationInternalPassesRoute,
  ConfigurationMcpRoute: ConfigurationMcpRoute,
  ConfigurationModerationRoute: ConfigurationModerationRoute,
  ConfigurationPricingRoute: ConfigurationPricingRoute,
  ConfigurationReferralRoute: ConfigurationReferralRoute,
  ConfigurationShippingRoute: ConfigurationShippingRoute,
  CouponRequestsCampaignIdRoute: CouponRequestsCampaignIdRoute,
  TvScreenKeyRoute: TvScreenKeyRoute,
  AccountingIndexRoute: AccountingIndexRoute,
  ApiRequestsIndexRoute: ApiRequestsIndexRoute,
  ApiUsageIndexRoute: ApiUsageIndexRoute,
  CardScannerIndexRoute: CardScannerIndexRoute,
  CatalogueV2IndexRoute: CatalogueV2IndexRoute,
  CouponRequestsIndexRoute: CouponRequestsIndexRoute,
  DevToolsIndexRoute: DevToolsIndexRoute,
  DiscordBotIndexRoute: DiscordBotIndexRoute,
  PriceDataAccessIndexRoute: PriceDataAccessIndexRoute,
  ReviewAppealsIndexRoute: ReviewAppealsIndexRoute,
  AccountingMonthlyClosesCloseIdRoute: AccountingMonthlyClosesCloseIdRoute,
  AccountingVatDeclarationsDeclarationIdRoute:
    AccountingVatDeclarationsDeclarationIdRoute,
  CardScannerEvalJobsJobIdRoute: CardScannerEvalJobsJobIdRoute,
  CardScannerEvalSuitesSuiteIdRoute: CardScannerEvalSuitesSuiteIdRoute,
  CardScannerJobsJobIdRoute: CardScannerJobsJobIdRoute,
  CardScannerModelsModelIdRoute: CardScannerModelsModelIdRoute,
  CatalogueV2ProposalsProposalIdRoute: CatalogueV2ProposalsProposalIdRoute,
  CatalogueAiMatcherRunIdRoute: CatalogueAiMatcherRunIdRoute,
  CatalogueGamesGameSlugRoute: CatalogueGamesGameSlugRoute,
  AccountingMonthlyClosesIndexRoute: AccountingMonthlyClosesIndexRoute,
  AccountingReconciliationIndexRoute: AccountingReconciliationIndexRoute,
  AccountingVatDeclarationsIndexRoute: AccountingVatDeclarationsIndexRoute,
  AccountingVatRemittancesIndexRoute: AccountingVatRemittancesIndexRoute,
  CatalogueV2ProposalsIndexRoute: CatalogueV2ProposalsIndexRoute,
  CatalogueAiMatcherIndexRoute: CatalogueAiMatcherIndexRoute,
  CatalogueFeaturedExpansionsIndexRoute: CatalogueFeaturedExpansionsIndexRoute,
  CatalogueGamesIndexRoute: CatalogueGamesIndexRoute,
  CatalogueUpcomingIndexRoute: CatalogueUpcomingIndexRoute,
  ToolsCrmIndexRoute: ToolsCrmIndexRoute,
  ToolsPriceImportsIndexRoute: ToolsPriceImportsIndexRoute,
  AccountingReconciliationRegionPeriodRoute:
    AccountingReconciliationRegionPeriodRoute,
  CatalogueGamesGameSlugLocksRoute: CatalogueGamesGameSlugLocksRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
